import { ethers } from 'ethers';
import Ajv from 'ajv';
import { request, batchRequests } from 'graphql-request';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var abi$6 = [
	{
		inputs: [
			{
				internalType: "string",
				name: "name",
				type: "string"
			},
			{
				internalType: "address",
				name: "target",
				type: "address"
			}
		],
		name: "set",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "name",
				type: "string"
			}
		],
		name: "get",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

var abi$5 = [
	{
		inputs: [
			{
				internalType: "contract IResolver",
				name: "resolver",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		inputs: [
			{
				internalType: "string",
				name: "releaseVersion",
				type: "string"
			}
		],
		name: "loadFramework",
		outputs: [
			{
				components: [
					{
						internalType: "contract ISuperfluid",
						name: "superfluid",
						type: "address"
					},
					{
						internalType: "contract ISuperTokenFactory",
						name: "superTokenFactory",
						type: "address"
					},
					{
						internalType: "contract ISuperAgreement",
						name: "agreementCFAv1",
						type: "address"
					},
					{
						internalType: "contract ISuperAgreement",
						name: "agreementIDAv1",
						type: "address"
					}
				],
				internalType: "struct SuperfluidLoader.Framework",
				name: "result",
				type: "tuple"
			}
		],
		stateMutability: "view",
		type: "function"
	}
];

var MONTHS_PER_YEAR = 12;
var DAYS_PER_MONTH = 30;
var HOURS_PER_DAY = 24;
var MINUTES_PER_HOUR = 60;
var SECONDS_PER_MINUTE = 60;
var chainIds = [
    3,
    4,
    5,
    42,
    100,
    137,
    80001, // MUMBAI
];
var networkNames = [
    "ropsten",
    "rinkeby",
    "goerli",
    "kovan",
    "xdai",
    "matic",
    "mumbai",
];
var chainIdToDataMap = new Map([
    [
        3,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-ropsten",
            networkName: "ropsten",
            resolverAddress: "0x3b44e06D96BcA9412CBc23F80F41B9e30933571a",
        },
    ],
    [
        4,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-rinkeby",
            networkName: "rinkeby",
            resolverAddress: "0x659635Fab0A0cef1293f7eb3c7934542B6A6B31A",
        },
    ],
    [
        5,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-goerli",
            networkName: "goerli",
            resolverAddress: "0x3710AB3fDE2B61736B8BB0CE845D6c61F667a78E",
        },
    ],
    [
        42,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-kovan",
            networkName: "kovan",
            resolverAddress: "0x851d3dd9dc97c1df1DA73467449B3893fc76D85B",
        },
    ],
    [
        100,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-xdai",
            networkName: "xdai",
            resolverAddress: "0xD2009765189164b495c110D61e4D301729079911",
        },
    ],
    [
        137,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-matic",
            networkName: "matic",
            resolverAddress: "0xE0cc76334405EE8b39213E620587d815967af39C",
        },
    ],
    [
        80001,
        {
            subgraphAPIEndpoint: "https://api.thegraph.com/subgraphs/name/superfluid-finance/protocol-dev-mumbai",
            networkName: "mumbai",
            resolverAddress: "0x8C54C83FbDe3C59e59dd6E324531FB93d4F504d3",
        },
    ],
]);
var networkNameToChainIdMap = new Map([
    ["ropsten", 3],
    ["rinkeby", 4],
    ["goerli", 5],
    ["kovan", 42],
    ["xdai", 100],
    ["matic", 137],
    ["mumbai", 80001],
]);

var errorTypeToTitleMap = new Map([
    ["FRAMEWORK_INITIALIZATION", "Framework Initialization"],
    ["SUPERTOKEN_INITIALIZATION", "SuperToken Initialization"],
    ["CREATE_SIGNER", "Create Signer"],
    ["SUPERTOKEN_READ", "SuperToken Read"],
    ["SUBGRAPH_ERROR", "Subgraph"],
    ["CFAV1_READ", "ConstantFlowAgreementV1 Read"],
    ["IDAV1_READ", "InstantDistributionAgreementV1 Read"],
    ["INVALID_ADDRESS", "Invalid Address"],
    ["INVALID_OBJECT", "Invalid Object"],
    ["POPULATE_TRANSACTION", "Populate Transaction"],
    ["EXECUTE_TRANSACTION", "Execute Transaction"],
    ["SIGN_TRANSACTION", "Sign Transaction"],
    ["UNSUPPORTED_OPERATION", "Unsupported Batch Call Operation"],
    ["MISSING_TRANSACTION_PROPERTIES", "Missing Transaction Properties"],
    ["BATCH_CALL_ERROR", "Batch Call"],
    ["NETWORK_MISMATCH", "Network Mismatch"],
    ["UNSUPPORTED_WEB_3_ONLY", "Unsupported Web 3 Only"],
]);
var SFError = /** @class */ (function () {
    function SFError(props) {
        var type = props.type, errorObject = props.errorObject, customMessage = props.customMessage;
        var title = errorTypeToTitleMap.get(type);
        var formattedErrorObject = errorObject
            ? ": " + JSON.stringify(errorObject)
            : "";
        this.type = type;
        this.errorObject = errorObject;
        this.message =
            title + " Error - " + customMessage + formattedErrorObject;
    }
    return SFError;
}());

var EMPTY = "0x";
/**
 * @dev Checks if address is a valid ethereum address and normalizes so it can be used by both subgraph and web3.
 * @param address
 * @returns The normalized address.
 */
var normalizeAddress = function (address) {
    if (!address)
        return "";
    if (ethers.utils.isAddress(address) === false) {
        throw new SFError({
            type: "INVALID_ADDRESS",
            customMessage: "The address you have entered is not a valid ethereum address.",
        });
    }
    return address.toLowerCase();
};
var isNullOrEmpty = function (str) {
    return str == null || str === "";
};
/**
 * @dev Removes the 8-character signature hash from `callData`.
 * @param callData
 * @returns function parameters
 */
var removeSigHashFromCallData = function (callData) {
    return EMPTY.concat(callData.slice(10));
};
/**
 * @dev A wrapper function for getting the ethers TransactionDescription object given fragments (e.g. ABI), callData and the value amount sent.
 * @param fragments ABI
 * @param data callData of a function
 * @param value amount of ether sent
 * @returns ethers.TransactionDescription object
 */
var getTransactionDescription = function (fragments, data, value) {
    var iface = new ethers.utils.Interface(fragments);
    var txnDescription = iface.parseTransaction({ data: data, value: value });
    return txnDescription;
};
/**
 * @dev Gets the per second flow rate given an `amountPerYear` value.
 * @param amountPerYear the amount you want to stream per year
 * @returns flow rate per second
 */
var getPerSecondFlowRateByYear = function (amountPerYear) {
    return Math.round(Number(amountPerYear) *
        MONTHS_PER_YEAR *
        DAYS_PER_MONTH *
        HOURS_PER_DAY *
        MINUTES_PER_HOUR *
        SECONDS_PER_MINUTE).toString();
};
/**
 * @dev Gets the per second flow rate given an `amountPerMonth` value.
 * @param amountPerMonth the amount you want to stream per month
 * @returns flow rate per second
 */
var getPerSecondFlowRateByMonth = function (amountPerMonth) {
    return Math.round(Number(amountPerMonth) *
        DAYS_PER_MONTH *
        HOURS_PER_DAY *
        MINUTES_PER_HOUR *
        SECONDS_PER_MINUTE).toString();
};
/**
 * @dev Gets the per second flow rate given an `amountPerDay` value.
 * @param amountPerDay the amount you want to stream per day
 * @returns flow rate per second
 */
var getPerSecondFlowRateByDay = function (amountPerDay) {
    return Math.round(Number(amountPerDay) *
        HOURS_PER_DAY *
        MINUTES_PER_HOUR *
        SECONDS_PER_MINUTE).toString();
};
/**
 * @dev The formula for calculating the flowed amount since updated using Subgraph data.
 * @param netFlowRate the net flow rate of the user
 * @param currentTimestamp the current timestamp
 * @param updatedAtTimestamp the updated at timestamp of the `AccountTokenSnapshot` entity
 * @returns the flowed amount since the updatedAt timestamp
 */
var flowedAmountSinceUpdatedAt = function (_a) {
    var netFlowRate = _a.netFlowRate, currentTimestamp = _a.currentTimestamp, updatedAtTimestamp = _a.updatedAtTimestamp;
    return ((Number(currentTimestamp) - Number(updatedAtTimestamp)) *
        Number(netFlowRate));
};
/**
 * @dev The formula for calculating the total amount distributed to the subscriber (pending or received).
 * @param indexSubscriptions the index subscriptions of a single token from an account.
 * @returns the total amount received since updated at (both pending and actually distributed)
 */
var subscriptionTotalAmountDistributedSinceUpdated = function (indexSubscriptions) {
    return indexSubscriptions.reduce(function (x, y) {
        return x +
            (Number(y.index.indexValue) - Number(y.indexValueUntilUpdatedAt)) *
                Number(y.units);
    }, 0);
};
/**
 * @dev The formula for calculating the total amount received (approved subscriptions).
 * @param indexSubscriptions the index subscriptions of a single token from an account.
 * @returns the total amount received since updated at (actually distributed into wallet)
 */
var subscriptionTotalAmountReceivedSinceUpdated = function (indexSubscriptions) {
    return indexSubscriptions
        .filter(function (x) { return x.approved; })
        .reduce(function (x, y) {
        return x +
            (Number(y.index.indexValue) -
                Number(y.indexValueUntilUpdatedAt)) *
                Number(y.units);
    }, 0);
};
/**
 * @dev The formula for calculating the total amount that is claimable.
 * @param indexSubscriptions the index subscriptions of a single token from an account.
 * @returns the total amount that can be claimed since updated at
 */
var subscriptionTotalAmountClaimableSinceUpdatedAt = function (indexSubscriptions) {
    return (subscriptionTotalAmountDistributedSinceUpdated(indexSubscriptions) -
        subscriptionTotalAmountReceivedSinceUpdated(indexSubscriptions));
};
var getStringCurrentTimeInSeconds = function () {
    return Math.floor(new Date().getTime() / 1000);
};
var getSanitizedTimestamp = function (timestamp) {
    return new Date(Number(timestamp.toString()) * 1000);
};
/**
 * @dev The formula for calculating the balance until updated at of a user (claimable + received tokens from index)
 * @param currentBalance the current balance until updated at from the `AccountTokenSnapshot` entity
 * @param netFlowRate the net flow rate of the user
 * @param currentTimestamp the current timestamp
 * @param updatedAtTimestamp the updated at timestamp of the `AccountTokenSnapshot` entity
 * @returns the balance since the updated at timestamp
 */
var getBalance = function (_a) {
    var currentBalance = _a.currentBalance, netFlowRate = _a.netFlowRate, currentTimestamp = _a.currentTimestamp, updatedAtTimestamp = _a.updatedAtTimestamp, indexSubscriptions = _a.indexSubscriptions;
    return (Number(currentBalance) +
        flowedAmountSinceUpdatedAt({
            netFlowRate: netFlowRate,
            currentTimestamp: currentTimestamp,
            updatedAtTimestamp: updatedAtTimestamp,
        }) +
        subscriptionTotalAmountReceivedSinceUpdated(indexSubscriptions));
};

var validateFrameworkConstructorOptions = function (options) {
    if (!options.chainId && !options.networkName) {
        throw new SFError({
            type: "FRAMEWORK_INITIALIZATION",
            customMessage: "You must input chainId or networkName.",
        });
    }
    // if the user inputs a custom network (local, they have to specify this)
    if (options.networkName &&
        networkNames.includes(options.networkName) &&
        options.chainId &&
        chainIds.includes(options.chainId) &&
        networkNameToChainIdMap.get(options.networkName) !== options.chainId) {
        throw new SFError({
            type: "FRAMEWORK_INITIALIZATION",
            customMessage: "The network name and chainId you have selected don't match.",
        });
    }
    if (!options.provider) {
        throw new SFError({
            type: "FRAMEWORK_INITIALIZATION",
            customMessage: "You must pass in a provider when initializing the framework.",
        });
    }
    // if the user inputs a networkName or chainId that isn't part of the resolver
    // that is, an unsupported network/chain
    if ((options.networkName != null &&
        !networkNames.includes(options.networkName)) ||
        (options.chainId != null && !chainIds.includes(options.chainId))) {
        if (options.dataMode !== "WEB3_ONLY" &&
            isNullOrEmpty(options.customSubgraphQueriesEndpoint)) {
            throw new SFError({
                type: "FRAMEWORK_INITIALIZATION",
                customMessage: "You must input your own custom subgraph query endpoint if you use an unsupported network with dataMode set to SUBGRAPH_ONLY or SUBGRAPH_WEB3.",
            });
        }
        if (isNullOrEmpty(options.resolverAddress)) {
            throw new SFError({
                type: "FRAMEWORK_INITIALIZATION",
                customMessage: "You must input your own resolver address if you use an unsupported network.",
            });
        }
    }
};
/**
 * @dev options.networkName is casted as not null as we check to ensure chainId or networkName is not null.
 * @param options
 * @returns SubgraphQueriesEndpoint which is a custom endpoint or based on selected network
 */
var getSubgraphQueriesEndpoint = function (options) {
    if (options.chainId && chainIdToDataMap.get(options.chainId)) {
        return chainIdToDataMap.get(options.chainId).subgraphAPIEndpoint;
    }
    if (options.networkName &&
        networkNameToChainIdMap.get(options.networkName) &&
        chainIdToDataMap.get(networkNameToChainIdMap.get(options.networkName))) {
        return chainIdToDataMap.get(networkNameToChainIdMap.get(options.networkName)).subgraphAPIEndpoint;
    }
    /* istanbul ignore next */
    throw new SFError({
        type: "FRAMEWORK_INITIALIZATION",
        customMessage: "Something went wrong, this should never occur.",
    });
};
/**
 * @dev We check that the user has input a networkName or chainId and that they are both supported.
 * @param options.chainId the chainId of the desired network
 * @param options.networkName the name of the desired network
 * @returns the network name
 */
var getNetworkName = function (options) {
    var networkName = chainIdToDataMap.get(options.chainId) != null
        ? chainIdToDataMap.get(options.chainId).networkName
        : "custom";
    return options.networkName || networkName;
};

var abi$4 = [
	{
		inputs: [
			{
				internalType: "bool",
				name: "nonUpgradable",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "appWhiteListingEnabled",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes32",
				name: "agreementType",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "code",
				type: "address"
			}
		],
		name: "AgreementClassRegistered",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes32",
				name: "agreementType",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "code",
				type: "address"
			}
		],
		name: "AgreementClassUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			}
		],
		name: "AppRegistered",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes32",
				name: "uuid",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "codeAddress",
				type: "address"
			}
		],
		name: "CodeUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "contract ISuperfluidGovernance",
				name: "oldGov",
				type: "address"
			},
			{
				indexed: false,
				internalType: "contract ISuperfluidGovernance",
				name: "newGov",
				type: "address"
			}
		],
		name: "GovernanceReplaced",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "reason",
				type: "uint256"
			}
		],
		name: "Jail",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "contract ISuperTokenFactory",
				name: "newFactory",
				type: "address"
			}
		],
		name: "SuperTokenFactoryUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperToken",
				name: "token",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "code",
				type: "address"
			}
		],
		name: "SuperTokenLogicUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "APP_WHITE_LISTING_ENABLED",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "CALLBACK_GAS_LIMIT",
		outputs: [
			{
				internalType: "uint64",
				name: "",
				type: "uint64"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "MAX_APP_LEVEL",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "NON_UPGRADABLE_DEPLOYMENT",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getCodeAddress",
		outputs: [
			{
				internalType: "address",
				name: "codeAddress",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidGovernance",
				name: "gov",
				type: "address"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "proxiableUUID",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newAddress",
				type: "address"
			}
		],
		name: "updateCode",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getGovernance",
		outputs: [
			{
				internalType: "contract ISuperfluidGovernance",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidGovernance",
				name: "newGov",
				type: "address"
			}
		],
		name: "replaceGovernance",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperAgreement",
				name: "agreementClassLogic",
				type: "address"
			}
		],
		name: "registerAgreementClass",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperAgreement",
				name: "agreementClassLogic",
				type: "address"
			}
		],
		name: "updateAgreementClass",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "agreementType",
				type: "bytes32"
			}
		],
		name: "isAgreementTypeListed",
		outputs: [
			{
				internalType: "bool",
				name: "yes",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperAgreement",
				name: "agreementClass",
				type: "address"
			}
		],
		name: "isAgreementClassListed",
		outputs: [
			{
				internalType: "bool",
				name: "yes",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "agreementType",
				type: "bytes32"
			}
		],
		name: "getAgreementClass",
		outputs: [
			{
				internalType: "contract ISuperAgreement",
				name: "agreementClass",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "bitmap",
				type: "uint256"
			}
		],
		name: "mapAgreementClasses",
		outputs: [
			{
				internalType: "contract ISuperAgreement[]",
				name: "agreementClasses",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "bitmap",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "agreementType",
				type: "bytes32"
			}
		],
		name: "addToAgreementClassesBitmap",
		outputs: [
			{
				internalType: "uint256",
				name: "newBitmap",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "bitmap",
				type: "uint256"
			},
			{
				internalType: "bytes32",
				name: "agreementType",
				type: "bytes32"
			}
		],
		name: "removeFromAgreementClassesBitmap",
		outputs: [
			{
				internalType: "uint256",
				name: "newBitmap",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getSuperTokenFactory",
		outputs: [
			{
				internalType: "contract ISuperTokenFactory",
				name: "factory",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getSuperTokenFactoryLogic",
		outputs: [
			{
				internalType: "address",
				name: "logic",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperTokenFactory",
				name: "newFactory",
				type: "address"
			}
		],
		name: "updateSuperTokenFactory",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperToken",
				name: "token",
				type: "address"
			}
		],
		name: "updateSuperTokenLogic",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "configWord",
				type: "uint256"
			}
		],
		name: "registerApp",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "configWord",
				type: "uint256"
			},
			{
				internalType: "string",
				name: "registrationKey",
				type: "string"
			}
		],
		name: "registerAppWithKey",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "configWord",
				type: "uint256"
			}
		],
		name: "registerAppByFactory",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			}
		],
		name: "isApp",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "appAddr",
				type: "address"
			}
		],
		name: "getAppLevel",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			}
		],
		name: "getAppManifest",
		outputs: [
			{
				internalType: "bool",
				name: "isSuperApp",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "isJailed",
				type: "bool"
			},
			{
				internalType: "uint256",
				name: "noopMask",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			}
		],
		name: "isAppJailed",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "targetApp",
				type: "address"
			}
		],
		name: "allowCompositeApp",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "contract ISuperApp",
				name: "targetApp",
				type: "address"
			}
		],
		name: "isCompositeAppAllowed",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			},
			{
				internalType: "bool",
				name: "isTermination",
				type: "bool"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "callAppBeforeCallback",
		outputs: [
			{
				internalType: "bytes",
				name: "cbdata",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			},
			{
				internalType: "bool",
				name: "isTermination",
				type: "bool"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "callAppAfterCallback",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			},
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "appAllowanceGranted",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "appAllowanceUsed",
				type: "int256"
			},
			{
				internalType: "contract ISuperfluidToken",
				name: "appAllowanceToken",
				type: "address"
			}
		],
		name: "appCallbackPush",
		outputs: [
			{
				internalType: "bytes",
				name: "appCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			},
			{
				internalType: "int256",
				name: "appAllowanceUsedDelta",
				type: "int256"
			}
		],
		name: "appCallbackPop",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			},
			{
				internalType: "uint256",
				name: "appAllowanceWantedMore",
				type: "uint256"
			},
			{
				internalType: "int256",
				name: "appAllowanceUsedDelta",
				type: "int256"
			}
		],
		name: "ctxUseAllowance",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			},
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "reason",
				type: "uint256"
			}
		],
		name: "jailApp",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperAgreement",
				name: "agreementClass",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "callAgreement",
		outputs: [
			{
				internalType: "bytes",
				name: "returnedData",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			}
		],
		name: "callAppAction",
		outputs: [
			{
				internalType: "bytes",
				name: "returnedData",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperAgreement",
				name: "agreementClass",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "callAgreementWithContext",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "returnedData",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperApp",
				name: "app",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "callData",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "callAppActionWithContext",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "decodeCtx",
		outputs: [
			{
				components: [
					{
						internalType: "uint8",
						name: "appLevel",
						type: "uint8"
					},
					{
						internalType: "uint8",
						name: "callType",
						type: "uint8"
					},
					{
						internalType: "uint256",
						name: "timestamp",
						type: "uint256"
					},
					{
						internalType: "address",
						name: "msgSender",
						type: "address"
					},
					{
						internalType: "bytes4",
						name: "agreementSelector",
						type: "bytes4"
					},
					{
						internalType: "bytes",
						name: "userData",
						type: "bytes"
					},
					{
						internalType: "uint256",
						name: "appAllowanceGranted",
						type: "uint256"
					},
					{
						internalType: "uint256",
						name: "appAllowanceWanted",
						type: "uint256"
					},
					{
						internalType: "int256",
						name: "appAllowanceUsed",
						type: "int256"
					},
					{
						internalType: "address",
						name: "appAddress",
						type: "address"
					},
					{
						internalType: "contract ISuperfluidToken",
						name: "appAllowanceToken",
						type: "address"
					}
				],
				internalType: "struct ISuperfluid.Context",
				name: "context",
				type: "tuple"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "isCtxValid",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint32",
						name: "operationType",
						type: "uint32"
					},
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct ISuperfluid.Operation[]",
				name: "operations",
				type: "tuple[]"
			}
		],
		name: "batchCall",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				components: [
					{
						internalType: "uint32",
						name: "operationType",
						type: "uint32"
					},
					{
						internalType: "address",
						name: "target",
						type: "address"
					},
					{
						internalType: "bytes",
						name: "data",
						type: "bytes"
					}
				],
				internalType: "struct ISuperfluid.Operation[]",
				name: "operations",
				type: "tuple[]"
			}
		],
		name: "forwardBatchCall",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "forwarder",
				type: "address"
			}
		],
		name: "isTrustedForwarder",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "versionRecipient",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "pure",
		type: "function"
	}
];

/**
 * @dev Operation Helper Class
 * @description A helper class to create `Operation` objects which can be executed or batched.
 */
var Operation = /** @class */ (function () {
    function Operation(txn, type) {
        var _this = this;
        /**
         * @dev Executes the operation via the provided signer.
         * @description Populates all fields of the transaction, signs it and sends it to the network.
         * @param signer The signer of the transacation
         * @returns {ethers.providers.TransactionResponse} A TransactionResponse object which can be awaited
         */
        this.exec = function (signer) { return __awaiter(_this, void 0, void 0, function () {
            var populatedTransaction, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getPopulatedTransactionRequest(signer)];
                    case 1:
                        populatedTransaction = _a.sent();
                        return [4 /*yield*/, signer.sendTransaction(populatedTransaction)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_1 = _a.sent();
                        throw new SFError({
                            type: "EXECUTE_TRANSACTION",
                            customMessage: "There was an error executing the transaction",
                            errorObject: err_1,
                        });
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         * @dev Get the populated transaction by awaiting `populateTransactionPromise`.
         * @description Note that we need to populate the txn with the signer.
         * @returns {Promise<TransactionRequest>}
         */
        this.getPopulatedTransactionRequest = function (signer) { return __awaiter(_this, void 0, void 0, function () {
            var prePopulated, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.populateTransactionPromise];
                    case 1:
                        prePopulated = _a.sent();
                        return [4 /*yield*/, signer.populateTransaction(prePopulated)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_2 = _a.sent();
                        /* istanbul ignore next */
                        throw new SFError({
                            type: "POPULATE_TRANSACTION",
                            customMessage: "There was an error populating the transaction",
                            errorObject: err_2,
                        });
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         * @dev Signs the populated transaction via the provided signer (what you intend on sending to the network).
         * @param signer The signer of the transacation
         * @returns {Promise<string>} Fully serialized, signed transaction
         */
        this.getSignedTransaction = function (signer) { return __awaiter(_this, void 0, void 0, function () {
            var populatedTransaction, signedTxn, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getPopulatedTransactionRequest(signer)];
                    case 1:
                        populatedTransaction = _a.sent();
                        return [4 /*yield*/, signer.signTransaction(populatedTransaction)];
                    case 2:
                        signedTxn = _a.sent();
                        return [2 /*return*/, signedTxn];
                    case 3:
                        err_3 = _a.sent();
                        throw new SFError({
                            type: "SIGN_TRANSACTION",
                            customMessage: "There was an error signing the transaction",
                            errorObject: err_3,
                        });
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         * @dev Gets the transaction hash of the transaction.
         * @description Calculates this by getting the keccak256 hash of the signedTxn.
         * @param signer The signer of the transacation
         * @returns {Promise<string>} The transaction hash of the transaction
         */
        this.getTransactionHash = function (signer) { return __awaiter(_this, void 0, void 0, function () {
            var signedTxn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSignedTransaction(signer)];
                    case 1:
                        signedTxn = _a.sent();
                        return [2 /*return*/, ethers.utils.keccak256(signedTxn)];
                }
            });
        }); };
        this.populateTransactionPromise = txn;
        this.type = type;
    }
    return Operation;
}());

/**
 * @dev Host Helper Class
 * @description A helper class which can be used as a standalone class to populate call agreement transactions.
 */
var Host = /** @class */ (function () {
    function Host(hostAddress) {
        var _this = this;
        /**
         * @dev Creates an Operation of the `callAgreement` function on the host contract.
         * @param agreementAddress the agreement address (cfa or ida address)
         * @param callData the encoded callData for the function
         * @param userData any additional user data
         * @returns {Operation} an `Operation` class
         */
        this.populateCallAgreementTxnAndReturnOperation = function (agreementAddress, callData, userData) {
            var txn = _this.hostContract.populateTransaction.callAgreement(agreementAddress, callData, userData || "0x");
            return new Operation(txn, "SUPERFLUID_CALL_AGREEMENT");
        };
        this.hostContract = new ethers.Contract(hostAddress, abi$4);
    }
    return Host;
}());

var operationTypeStringToTypeMap = new Map([
    ["ERC20_APPROVE", 1],
    ["ERC20_TRANSFER_FROM", 2],
    ["SUPERTOKEN_UPGRADE", 101],
    ["SUPERTOKEN_DOWNGRADE", 102],
    ["SUPERFLUID_CALL_AGREEMENT", 201],
    ["CALL_APP_ACTION", 202],
]);
/**
 * @dev BatchCall Helper Class
 * @description A helper class to create `BatchCall` objects which can be executed.
 */
var BatchCall = /** @class */ (function () {
    function BatchCall(options) {
        var _this = this;
        /**
         * @dev Gets the call agreement function arguments.
         * @param callData callData of the function
         * @returns {ethers.utils.Result} call agreement function arguments
         */
        this.getCallAgreementFunctionArgs = function (callData) {
            return getTransactionDescription(abi$4, callData).args;
        };
        /**
         * @dev Given an `Operation` object, gets the `OperationStruct` object.
         * @param operation an `Operation` object
         * @param index the index of the `Operation` in the batchCall
         * @returns {Promise<OperationStruct>} OperationStruct object for batchCall
         */
        this.getOperationStruct = function (operation, index) { return __awaiter(_this, void 0, void 0, function () {
            var operationType, populatedTransaction, functionArgs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        operationType = operationTypeStringToTypeMap.get(operation.type);
                        return [4 /*yield*/, operation.populateTransactionPromise];
                    case 1:
                        populatedTransaction = _a.sent();
                        if (!operationType) {
                            throw new SFError({
                                type: "UNSUPPORTED_OPERATION",
                                customMessage: "The operation at index " + index + " is unsupported.",
                            });
                        }
                        /* istanbul ignore next */
                        if (!populatedTransaction.to || !populatedTransaction.data) {
                            throw new SFError({
                                type: "MISSING_TRANSACTION_PROPERTIES",
                                customMessage: "The transaction is missing the to or data property.",
                            });
                        }
                        // Handles the Superfluid Call Agreement
                        // The only operation which has a target that is not the
                        // same as the to property of the transaction.
                        if (operation.type === "SUPERFLUID_CALL_AGREEMENT") {
                            functionArgs = this.getCallAgreementFunctionArgs(populatedTransaction.data);
                            return [2 /*return*/, {
                                    operationType: operationType,
                                    target: functionArgs["agreementClass"],
                                    data: functionArgs["callData"],
                                }];
                        }
                        // Handles other cases which are not call agreeement operation
                        return [2 /*return*/, {
                                operationType: operationType,
                                target: populatedTransaction.to,
                                data: removeSigHashFromCallData(populatedTransaction.data),
                            }];
                }
            });
        }); };
        /**
         * @dev Executes a batch call given the operations on this class.
         * @param signer the signer of the transaction
         * @returns {Promise<ethers.ContractTransaction>} ContractTransaction object
         */
        this.exec = function (signer) { return __awaiter(_this, void 0, void 0, function () {
            var operationStructArray, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, Promise.all(this.getOperationStructArrayPromises)];
                    case 1:
                        operationStructArray = _a.sent();
                        return [4 /*yield*/, this.host.hostContract
                                .connect(signer)
                                .batchCall(operationStructArray)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_1 = _a.sent();
                        throw new SFError({
                            type: "BATCH_CALL_ERROR",
                            customMessage: "There was an error executing your batch call:",
                            errorObject: err_1,
                        });
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /* istanbul ignore next */
        // TODO: user signs the transaction they'd like to execute and gives
        // this data to the trusted forwarder to sign
        /**
         * @dev Executes a forward batch call given the operations on this class.
         * @param signer the signer of the transaction
         * @returns {Promise<ethers.ContractTransaction>} ContractTransaction object
         */
        this.execForward = function (signer) { return __awaiter(_this, void 0, void 0, function () {
            var operationStructArray, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, Promise.all(this.getOperationStructArrayPromises)];
                    case 1:
                        operationStructArray = _a.sent();
                        return [4 /*yield*/, this.host.hostContract
                                .connect(signer)
                                .forwardBatchCall(operationStructArray)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        err_2 = _a.sent();
                        throw new SFError({
                            type: "BATCH_CALL_ERROR",
                            customMessage: "There was an error executing your batch call:",
                            errorObject: err_2,
                        });
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.options = options;
        this.host = new Host(options.config.hostAddress);
    }
    Object.defineProperty(BatchCall.prototype, "getOperationStructArrayPromises", {
        /**
         * @dev Gets an array of `OperationStruct` objects to be passed to batchCall.
         * @returns {Promise<OperationStruct>[]} array of operation struct promises
         */
        get: function () {
            var _this = this;
            return this.options.operations.map(function (x, i) {
                return _this.getOperationStruct(x, i);
            });
        },
        enumerable: false,
        configurable: true
    });
    return BatchCall;
}());

var abi$3 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				indexed: false,
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			},
			{
				indexed: false,
				internalType: "int256",
				name: "totalSenderFlowRate",
				type: "int256"
			},
			{
				indexed: false,
				internalType: "int256",
				name: "totalReceiverFlowRate",
				type: "int256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "FlowUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "time",
				type: "uint256"
			}
		],
		name: "realtimeBalanceOf",
		outputs: [
			{
				internalType: "int256",
				name: "dynamicBalance",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "agreementType",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			}
		],
		name: "getMaximumFlowRateFromDeposit",
		outputs: [
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			}
		],
		name: "getDepositRequiredForFlowRate",
		outputs: [
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "createFlow",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "updateFlow",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			}
		],
		name: "getFlow",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "agreementId",
				type: "bytes32"
			}
		],
		name: "getFlowByID",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "getAccountFlowInfo",
		outputs: [
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			},
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "getNetFlow",
		outputs: [
			{
				internalType: "int96",
				name: "flowRate",
				type: "int96"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "address",
				name: "receiver",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "deleteFlow",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var cfaInterface = new ethers.utils.Interface(abi$3);
/**
 * @dev Constant Flow Agreement V1 Helper Class
 * @description A helper class to interact with the CFAV1 contract.
 */
var ConstantFlowAgreementV1 = /** @class */ (function () {
    function ConstantFlowAgreementV1(options) {
        var _this = this;
        // CFA Read Functions
        /**
         * @dev Get the details of a flow.
         * @param superToken the superToken of the agreement
         * @param sender the sender of the flow
         * @param receiver the receiver of the flow
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */
        this.getFlow = function (_a) {
            var superToken = _a.superToken, sender = _a.sender, receiver = _a.receiver, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedToken, normalizedSender, normalizedReceiver, flowData, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            normalizedToken = normalizeAddress(superToken);
                            normalizedSender = normalizeAddress(sender);
                            normalizedReceiver = normalizeAddress(receiver);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.cfaContract
                                    .connect(providerOrSigner)
                                    .getFlow(normalizedToken, normalizedSender, normalizedReceiver)];
                        case 2:
                            flowData = _b.sent();
                            return [2 /*return*/, this._sanitizeflowInfo(flowData)];
                        case 3:
                            err_1 = _b.sent();
                            throw new SFError({
                                type: "CFAV1_READ",
                                customMessage: "There was an error getting the flow",
                                errorObject: err_1,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Get the flow info of an account (net flow).
         * @param superToken the superToken of the agreement
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */
        this.getAccountFlowInfo = function (_a) {
            var superToken = _a.superToken, account = _a.account, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedToken, normalizedAccount, flowData, err_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            normalizedToken = normalizeAddress(superToken);
                            normalizedAccount = normalizeAddress(account);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.cfaContract
                                    .connect(providerOrSigner)
                                    .getAccountFlowInfo(normalizedToken, normalizedAccount)];
                        case 2:
                            flowData = _b.sent();
                            return [2 /*return*/, this._sanitizeflowInfo(flowData)];
                        case 3:
                            err_2 = _b.sent();
                            throw new SFError({
                                type: "CFAV1_READ",
                                customMessage: "There was an error getting the account flow information",
                                errorObject: err_2,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Get the net flow of an account.
         * @param superToken the superToken of the agreement
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<string>} Web3 Flow info object
         */
        this.getNetFlow = function (_a) {
            var superToken = _a.superToken, account = _a.account, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedToken, normalizedAccount, err_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            normalizedToken = normalizeAddress(superToken);
                            normalizedAccount = normalizeAddress(account);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.cfaContract
                                    .connect(providerOrSigner)
                                    .getNetFlow(normalizedToken, normalizedAccount)];
                        case 2: return [2 /*return*/, (_b.sent()).toString()];
                        case 3:
                            err_3 = _b.sent();
                            throw new SFError({
                                type: "CFAV1_READ",
                                customMessage: "There was an error getting net flow",
                                errorObject: err_3,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        // CFA Write Functions
        /**
         * @dev Create a flow.
         * @param flowRate The specified flow rate.
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.createFlow = function (_a) {
            var flowRate = _a.flowRate, receiver = _a.receiver, superToken = _a.superToken, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var normalizedReceiver = normalizeAddress(receiver);
            var callData = cfaInterface.encodeFunctionData("createFlow", [
                normalizedToken,
                normalizedReceiver,
                flowRate,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.cfaV1Address, callData, userData);
        };
        /**
         * @dev Update a flow.
         * @param flowRate The specified flow rate.
         * @param receiver The receiver of the flow.
         * @param superToken The token to be flowed.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.updateFlow = function (_a) {
            var flowRate = _a.flowRate, receiver = _a.receiver, superToken = _a.superToken, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var normalizedReceiver = normalizeAddress(receiver);
            var callData = cfaInterface.encodeFunctionData("updateFlow", [
                normalizedToken,
                normalizedReceiver,
                flowRate,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.cfaV1Address, callData, userData);
        };
        /**
         * @dev Delete a flow.
         * @param superToken The token to be flowed.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.deleteFlow = function (_a) {
            var superToken = _a.superToken, sender = _a.sender, receiver = _a.receiver, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var normalizedSender = normalizeAddress(sender);
            var normalizedReceiver = normalizeAddress(receiver);
            var callData = cfaInterface.encodeFunctionData("deleteFlow", [
                normalizedToken,
                normalizedSender,
                normalizedReceiver,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.cfaV1Address, callData, userData);
        };
        /**
         * @dev Sanitizes flow info, converting BigNumber to string.
         * @param timestamp last updated timestamp of flow
         * @param flowRate the current flow rate
         * @param deposit the deposit amount
         * @param owedDeposit any owed depsit
         * @returns {IWeb3FlowInfo} sanitized web3 flow info
         */
        this._sanitizeflowInfo = function (_a) {
            var timestamp = _a.timestamp, flowRate = _a.flowRate, deposit = _a.deposit, owedDeposit = _a.owedDeposit;
            return {
                timestamp: getSanitizedTimestamp(timestamp),
                flowRate: flowRate.toString(),
                deposit: deposit.toString(),
                owedDeposit: owedDeposit.toString(),
            };
        };
        this.options = options;
        this.host = new Host(options.config.hostAddress);
    }
    Object.defineProperty(ConstantFlowAgreementV1.prototype, "cfaContract", {
        get: function () {
            return new ethers.Contract(this.options.config.cfaV1Address, abi$3);
        },
        enumerable: false,
        configurable: true
    });
    return ConstantFlowAgreementV1;
}());

var abi$2 = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "IndexCreated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "IndexDistributionClaimed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "IndexSubscribed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "units",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "IndexUnitsUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "IndexUnsubscribed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: true,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "oldIndexValue",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "newIndexValue",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "totalUnitsPending",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "totalUnitsApproved",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "IndexUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "SubscriptionApproved",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "SubscriptionDistributionClaimed",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "SubscriptionRevoked",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				indexed: false,
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				indexed: false,
				internalType: "uint128",
				name: "units",
				type: "uint128"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "SubscriptionUnitsUpdated",
		type: "event"
	},
	{
		inputs: [
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "time",
				type: "uint256"
			}
		],
		name: "realtimeBalanceOf",
		outputs: [
			{
				internalType: "int256",
				name: "dynamicBalance",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "agreementType",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "createIndex",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			}
		],
		name: "getIndex",
		outputs: [
			{
				internalType: "bool",
				name: "exist",
				type: "bool"
			},
			{
				internalType: "uint128",
				name: "indexValue",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "totalUnitsApproved",
				type: "uint128"
			},
			{
				internalType: "uint128",
				name: "totalUnitsPending",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "calculateDistribution",
		outputs: [
			{
				internalType: "uint256",
				name: "actualAmount",
				type: "uint256"
			},
			{
				internalType: "uint128",
				name: "newIndexValue",
				type: "uint128"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "uint128",
				name: "indexValue",
				type: "uint128"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "updateIndex",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "distribute",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "approveSubscription",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "revokeSubscription",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				internalType: "uint128",
				name: "units",
				type: "uint128"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "updateSubscription",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "address",
				name: "subscriber",
				type: "address"
			}
		],
		name: "getSubscription",
		outputs: [
			{
				internalType: "bool",
				name: "exist",
				type: "bool"
			},
			{
				internalType: "bool",
				name: "approved",
				type: "bool"
			},
			{
				internalType: "uint128",
				name: "units",
				type: "uint128"
			},
			{
				internalType: "uint256",
				name: "pendingDistribution",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "agreementId",
				type: "bytes32"
			}
		],
		name: "getSubscriptionByID",
		outputs: [
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "bool",
				name: "approved",
				type: "bool"
			},
			{
				internalType: "uint128",
				name: "units",
				type: "uint128"
			},
			{
				internalType: "uint256",
				name: "pendingDistribution",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "subscriber",
				type: "address"
			}
		],
		name: "listSubscriptions",
		outputs: [
			{
				internalType: "address[]",
				name: "publishers",
				type: "address[]"
			},
			{
				internalType: "uint32[]",
				name: "indexIds",
				type: "uint32[]"
			},
			{
				internalType: "uint128[]",
				name: "unitsList",
				type: "uint128[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "deleteSubscription",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract ISuperfluidToken",
				name: "token",
				type: "address"
			},
			{
				internalType: "address",
				name: "publisher",
				type: "address"
			},
			{
				internalType: "uint32",
				name: "indexId",
				type: "uint32"
			},
			{
				internalType: "address",
				name: "subscriber",
				type: "address"
			},
			{
				internalType: "bytes",
				name: "ctx",
				type: "bytes"
			}
		],
		name: "claim",
		outputs: [
			{
				internalType: "bytes",
				name: "newCtx",
				type: "bytes"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var idaInterface = new ethers.utils.Interface(abi$2);
/**
 * @dev Instant Distribution Agreement V1 Helper Class
 * @description A helper class to interact with the IDAV1 contract.
 */
var InstantDistributionAgreementV1 = /** @class */ (function () {
    function InstantDistributionAgreementV1(options) {
        var _this = this;
        // IDA Read Functions
        /**
         * @dev Get the details of a `Subscription`.
         * @param superToken the superToken of the agreement
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param subscriber the subscriber's address
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Subscription>} Web3 Subscription object
         */
        this.getSubscription = function (_a) {
            var superToken = _a.superToken, publisher = _a.publisher, indexId = _a.indexId, subscriber = _a.subscriber, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedToken, normalizedPublisher, normalizedSubscriber, subscription, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            normalizedToken = normalizeAddress(superToken);
                            normalizedPublisher = normalizeAddress(publisher);
                            normalizedSubscriber = normalizeAddress(subscriber);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.idaContract
                                    .connect(providerOrSigner)
                                    .getSubscription(normalizedToken, normalizedPublisher, indexId, normalizedSubscriber)];
                        case 2:
                            subscription = _b.sent();
                            return [2 /*return*/, {
                                    exist: subscription.exist,
                                    approved: subscription.approved,
                                    units: subscription.units.toString(),
                                    pendingDistribution: subscription.pendingDistribution.toString(),
                                }];
                        case 3:
                            err_1 = _b.sent();
                            throw new SFError({
                                type: "IDAV1_READ",
                                customMessage: "There was an error getting the subscription",
                                errorObject: err_1,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Get the details of an `Index`.
         * @param superToken the superToken of the agreement
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Index>} Web3 Index object
         */
        this.getIndex = function (_a) {
            var superToken = _a.superToken, publisher = _a.publisher, indexId = _a.indexId, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedToken, normalizedPublisher, index, err_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            normalizedToken = normalizeAddress(superToken);
                            normalizedPublisher = normalizeAddress(publisher);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.idaContract
                                    .connect(providerOrSigner)
                                    .getIndex(normalizedToken, normalizedPublisher, indexId)];
                        case 2:
                            index = _b.sent();
                            return [2 /*return*/, {
                                    exist: index.exist,
                                    indexValue: index.indexValue.toString(),
                                    totalUnitsApproved: index.totalUnitsApproved.toString(),
                                    totalUnitsPending: index.totalUnitsPending.toString(),
                                }];
                        case 3:
                            err_2 = _b.sent();
                            throw new SFError({
                                type: "IDAV1_READ",
                                customMessage: "There was an error getting the index",
                                errorObject: err_2,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        // IDA Write Functions
        /**
         * @dev Creates an IDA Index.
         * @param indexId The id of the index.
         * @param superToken The address of the `index` superToken.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.createIndex = function (_a) {
            var indexId = _a.indexId, superToken = _a.superToken, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var callData = idaInterface.encodeFunctionData("createIndex", [
                normalizedToken,
                indexId,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Distributes `amount` of `superToken` to an index
         * @param indexId The id of the index.
         * @param amount The amount of `superToken` to be distributed.
         * @param superToken The superToken to be distributed.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.distribute = function (_a) {
            var indexId = _a.indexId, amount = _a.amount, superToken = _a.superToken, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var callData = idaInterface.encodeFunctionData("distribute", [
                normalizedToken,
                indexId,
                amount,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Updates the `indexValue` of an index.
         * @description NOTE: It has the same effect as `distribute`, but is closer to the low level data structure of the index.
         * @param indexId The id of the index.
         * @param indexValue The new indexValue.
         * @param superToken The superToken to be distributed.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.updateIndexValue = function (_a) {
            var indexId = _a.indexId, indexValue = _a.indexValue, superToken = _a.superToken, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var callData = idaInterface.encodeFunctionData("updateIndex", [
                normalizedToken,
                indexId,
                indexValue,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Updates the `units` allocated to a Subscription.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose units you want to update.
         * @param units The amount of units you want to update to.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.updateSubscriptionUnits = function (_a) {
            var indexId = _a.indexId, superToken = _a.superToken, subscriber = _a.subscriber, units = _a.units, userData = _a.userData;
            var normalizedToken = normalizeAddress(superToken);
            var normalizedSubscriber = normalizeAddress(subscriber);
            var callData = idaInterface.encodeFunctionData("updateSubscription", [
                normalizedToken,
                indexId,
                normalizedSubscriber,
                units,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Approves a Subscription, so the Subscriber won't need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param publisher The publisher of the index you want to approve.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.approveSubscription = function (_a) {
            var indexId = _a.indexId, superToken = _a.superToken, publisher = _a.publisher, userData = _a.userData;
            var normalizedPublisher = normalizeAddress(publisher);
            var normalizedToken = normalizeAddress(superToken);
            var callData = idaInterface.encodeFunctionData("approveSubscription", [normalizedToken, normalizedPublisher, indexId, "0x"]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Revokes a Subscription, so the Subscriber will need to claim tokens when the Publisher distributres.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose subscription you want to revoke.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.revokeSubscription = function (_a) {
            var indexId = _a.indexId, superToken = _a.superToken, publisher = _a.publisher, userData = _a.userData;
            var normalizedPublisher = normalizeAddress(publisher);
            var normalizedToken = normalizeAddress(superToken);
            var callData = idaInterface.encodeFunctionData("revokeSubscription", [
                normalizedToken,
                normalizedPublisher,
                indexId,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Deletes a Subscription by setting the `units` allocated to the Subscriber to 0.
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose subscription you want to delete.
         * @param publisher The publisher address of the index you are targetting.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.deleteSubscription = function (_a) {
            var indexId = _a.indexId, superToken = _a.superToken, subscriber = _a.subscriber, publisher = _a.publisher, userData = _a.userData;
            var normalizedPublisher = normalizeAddress(publisher);
            var normalizedToken = normalizeAddress(superToken);
            var normalizedSubscriber = normalizeAddress(subscriber);
            var callData = idaInterface.encodeFunctionData("deleteSubscription", [
                normalizedToken,
                normalizedPublisher,
                indexId,
                normalizedSubscriber,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        /**
         * @dev Claims any pending tokens allocated to the Subscription (unapproved).
         * @param indexId The id of the index.
         * @param superToken The superToken of the index.
         * @param subscriber The subscriber address whose subscription you want to delete.
         * @param publisher The publisher address of the index you are targetting.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.claim = function (_a) {
            var indexId = _a.indexId, superToken = _a.superToken, subscriber = _a.subscriber, publisher = _a.publisher, userData = _a.userData;
            var normalizedPublisher = normalizeAddress(publisher);
            var normalizedToken = normalizeAddress(superToken);
            var normalizedSubscriber = normalizeAddress(subscriber);
            var callData = idaInterface.encodeFunctionData("claim", [
                normalizedToken,
                normalizedPublisher,
                indexId,
                normalizedSubscriber,
                "0x",
            ]);
            return _this.host.populateCallAgreementTxnAndReturnOperation(_this.options.config.idaV1Address, callData, userData);
        };
        this.options = options;
        this.host = new Host(options.config.hostAddress);
    }
    Object.defineProperty(InstantDistributionAgreementV1.prototype, "idaContract", {
        get: function () {
            return new ethers.Contract(this.options.config.idaV1Address, abi$2);
        },
        enumerable: false,
        configurable: true
    });
    return InstantDistributionAgreementV1;
}());

var abi$1 = [
	{
		inputs: [
			{
				internalType: "contract ISuperfluid",
				name: "host",
				type: "address"
			}
		],
		stateMutability: "nonpayable",
		type: "constructor"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "state",
				type: "bytes"
			}
		],
		name: "AgreementAccountStateUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "bytes32[]",
				name: "data",
				type: "bytes32[]"
			}
		],
		name: "AgreementCreated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "penaltyAccount",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "rewardAccount",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "rewardAmount",
				type: "uint256"
			}
		],
		name: "AgreementLiquidated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "address",
				name: "liquidatorAccount",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				indexed: true,
				internalType: "address",
				name: "penaltyAccount",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "bondAccount",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "rewardAmount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "bailoutAmount",
				type: "uint256"
			}
		],
		name: "AgreementLiquidatedBy",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "slotId",
				type: "uint256"
			}
		],
		name: "AgreementStateUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			}
		],
		name: "AgreementTerminated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				indexed: false,
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "bytes32[]",
				name: "data",
				type: "bytes32[]"
			}
		],
		name: "AgreementUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tokenHolder",
				type: "address"
			}
		],
		name: "AuthorizedOperator",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "bailoutAccount",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "bailoutAmount",
				type: "uint256"
			}
		],
		name: "Bailout",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "operatorData",
				type: "bytes"
			}
		],
		name: "Burned",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: "bytes32",
				name: "uuid",
				type: "bytes32"
			},
			{
				indexed: false,
				internalType: "address",
				name: "codeAddress",
				type: "address"
			}
		],
		name: "CodeUpdated",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "operatorData",
				type: "bytes"
			}
		],
		name: "Minted",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "tokenHolder",
				type: "address"
			}
		],
		name: "RevokedOperator",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				indexed: false,
				internalType: "bytes",
				name: "operatorData",
				type: "bytes"
			}
		],
		name: "Sent",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TokenDowngraded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "TokenUpgraded",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				internalType: "bytes32[]",
				name: "data",
				type: "bytes32[]"
			}
		],
		name: "createAgreement",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "getAccountActiveAgreements",
		outputs: [
			{
				internalType: "contract ISuperAgreement[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "dataLength",
				type: "uint256"
			}
		],
		name: "getAgreementData",
		outputs: [
			{
				internalType: "bytes32[]",
				name: "data",
				type: "bytes32[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "agreementClass",
				type: "address"
			},
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "slotId",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "dataLength",
				type: "uint256"
			}
		],
		name: "getAgreementStateSlot",
		outputs: [
			{
				internalType: "bytes32[]",
				name: "slotData",
				type: "bytes32[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getCodeAddress",
		outputs: [
			{
				internalType: "address",
				name: "codeAddress",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getHost",
		outputs: [
			{
				internalType: "address",
				name: "host",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		name: "isAccountCritical",
		outputs: [
			{
				internalType: "bool",
				name: "isCritical",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "isAccountCriticalNow",
		outputs: [
			{
				internalType: "bool",
				name: "isCritical",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		name: "isAccountSolvent",
		outputs: [
			{
				internalType: "bool",
				name: "isSolvent",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "isAccountSolventNow",
		outputs: [
			{
				internalType: "bool",
				name: "isSolvent",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				internalType: "address",
				name: "liquidator",
				type: "address"
			},
			{
				internalType: "address",
				name: "penaltyAccount",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "rewardAmount",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "bailoutAmount",
				type: "uint256"
			}
		],
		name: "makeLiquidationPayouts",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		name: "realtimeBalanceOf",
		outputs: [
			{
				internalType: "int256",
				name: "availableBalance",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "realtimeBalanceOfNow",
		outputs: [
			{
				internalType: "int256",
				name: "availableBalance",
				type: "int256"
			},
			{
				internalType: "uint256",
				name: "deposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "owedDeposit",
				type: "uint256"
			},
			{
				internalType: "uint256",
				name: "timestamp",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "int256",
				name: "delta",
				type: "int256"
			}
		],
		name: "settleBalance",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				internalType: "uint256",
				name: "dataLength",
				type: "uint256"
			}
		],
		name: "terminateAgreement",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "bytes32",
				name: "id",
				type: "bytes32"
			},
			{
				internalType: "bytes32[]",
				name: "data",
				type: "bytes32[]"
			}
		],
		name: "updateAgreementData",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "slotId",
				type: "uint256"
			},
			{
				internalType: "bytes32[]",
				name: "slotData",
				type: "bytes32[]"
			}
		],
		name: "updateAgreementStateSlot",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "contract IERC20",
				name: "underlyingToken",
				type: "address"
			},
			{
				internalType: "uint8",
				name: "underlyingDecimals",
				type: "uint8"
			},
			{
				internalType: "string",
				name: "n",
				type: "string"
			},
			{
				internalType: "string",
				name: "s",
				type: "string"
			}
		],
		name: "initialize",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "proxiableUUID",
		outputs: [
			{
				internalType: "bytes32",
				name: "",
				type: "bytes32"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "newAddress",
				type: "address"
			}
		],
		name: "updateCode",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "balance",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "holder",
				type: "address"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "addedValue",
				type: "uint256"
			}
		],
		name: "increaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "subtractedValue",
				type: "uint256"
			}
		],
		name: "decreaseAllowance",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "granularity",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "pure",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "send",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "burn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			},
			{
				internalType: "address",
				name: "tokenHolder",
				type: "address"
			}
		],
		name: "isOperatorFor",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "authorizeOperator",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "operator",
				type: "address"
			}
		],
		name: "revokeOperator",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "defaultOperators",
		outputs: [
			{
				internalType: "address[]",
				name: "",
				type: "address[]"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "operatorData",
				type: "bytes"
			}
		],
		name: "operatorSend",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			},
			{
				internalType: "bytes",
				name: "operatorData",
				type: "bytes"
			}
		],
		name: "operatorBurn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "selfMint",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "userData",
				type: "bytes"
			}
		],
		name: "selfBurn",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			}
		],
		name: "transferAll",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
		],
		name: "getUnderlyingToken",
		outputs: [
			{
				internalType: "address",
				name: "",
				type: "address"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "upgrade",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			},
			{
				internalType: "bytes",
				name: "data",
				type: "bytes"
			}
		],
		name: "upgradeTo",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "downgrade",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "operationApprove",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "operationTransferFrom",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "operationUpgrade",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "operationDowngrade",
		outputs: [
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var abi = [
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Approval",
		type: "event"
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: "address",
				name: "from",
				type: "address"
			},
			{
				indexed: true,
				internalType: "address",
				name: "to",
				type: "address"
			},
			{
				indexed: false,
				internalType: "uint256",
				name: "value",
				type: "uint256"
			}
		],
		name: "Transfer",
		type: "event"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "owner",
				type: "address"
			},
			{
				internalType: "address",
				name: "spender",
				type: "address"
			}
		],
		name: "allowance",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "spender",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "approve",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "account",
				type: "address"
			}
		],
		name: "balanceOf",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "decimals",
		outputs: [
			{
				internalType: "uint8",
				name: "",
				type: "uint8"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "name",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "symbol",
		outputs: [
			{
				internalType: "string",
				name: "",
				type: "string"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
		],
		name: "totalSupply",
		outputs: [
			{
				internalType: "uint256",
				name: "",
				type: "uint256"
			}
		],
		stateMutability: "view",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transfer",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	},
	{
		inputs: [
			{
				internalType: "address",
				name: "sender",
				type: "address"
			},
			{
				internalType: "address",
				name: "recipient",
				type: "address"
			},
			{
				internalType: "uint256",
				name: "amount",
				type: "uint256"
			}
		],
		name: "transferFrom",
		outputs: [
			{
				internalType: "bool",
				name: "",
				type: "bool"
			}
		],
		stateMutability: "nonpayable",
		type: "function"
	}
];

var Token = /** @class */ (function () {
    function Token(address) {
        var _this = this;
        // ERC20 Token Contract Read Functions
        /**
         * @dev Returns the allowance the `owner` has granted the `spender`.
         * @param owner the owner who has allotted the allowance
         * @param spender the spender who has received the allowance
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the allowance amount
         */
        this.allowance = function (_a) {
            var owner = _a.owner, spender = _a.spender, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedOwner, normalizedSpender, allowance, err_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            normalizedOwner = normalizeAddress(owner);
                            normalizedSpender = normalizeAddress(spender);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.tokenContract
                                    .connect(providerOrSigner)
                                    .allowance(normalizedOwner, normalizedSpender)];
                        case 2:
                            allowance = _b.sent();
                            return [2 /*return*/, allowance.toString()];
                        case 3:
                            err_1 = _b.sent();
                            throw new SFError({
                                type: "SUPERTOKEN_READ",
                                customMessage: "There was an error getting allowance",
                                errorObject: err_1,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Returns the ERC20 balanceOf the `account`, this can't be negative and will just display 0.
         * @param account the account you would like to query
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the token balance of `account`
         */
        this.balanceOf = function (_a) {
            var account = _a.account, providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedAccount, balanceOf, err_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            normalizedAccount = normalizeAddress(account);
                            return [4 /*yield*/, this.tokenContract
                                    .connect(providerOrSigner)
                                    .balanceOf(normalizedAccount)];
                        case 1:
                            balanceOf = _b.sent();
                            return [2 /*return*/, balanceOf.toString()];
                        case 2:
                            err_2 = _b.sent();
                            throw new SFError({
                                type: "SUPERTOKEN_READ",
                                customMessage: "There was an error getting balanceOf",
                                errorObject: err_2,
                            });
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Returns the token name
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the token name
         */
        this.name = function (_a) {
            var providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var name, err_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.tokenContract
                                    .connect(providerOrSigner)
                                    .name()];
                        case 1:
                            name = _b.sent();
                            return [2 /*return*/, name];
                        case 2:
                            err_3 = _b.sent();
                            throw new SFError({
                                type: "SUPERTOKEN_READ",
                                customMessage: "There was an error getting name",
                                errorObject: err_3,
                            });
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Returns the token symbol
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {string} the token symbol
         */
        this.symbol = function (_a) {
            var providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var symbol, err_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.tokenContract
                                    .connect(providerOrSigner)
                                    .symbol()];
                        case 1:
                            symbol = _b.sent();
                            return [2 /*return*/, symbol];
                        case 2:
                            err_4 = _b.sent();
                            throw new SFError({
                                type: "SUPERTOKEN_READ",
                                customMessage: "There was an error getting symbol",
                                errorObject: err_4,
                            });
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        /**
         * @dev Returns the total supply of the token.
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<string>} the total supply of the token
         */
        this.totalSupply = function (_a) {
            var providerOrSigner = _a.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                var totalSupply, err_5;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.tokenContract
                                    .connect(providerOrSigner)
                                    .totalSupply()];
                        case 1:
                            totalSupply = _b.sent();
                            return [2 /*return*/, totalSupply.toString()];
                        case 2:
                            err_5 = _b.sent();
                            throw new SFError({
                                type: "SUPERTOKEN_READ",
                                customMessage: "There was an error getting totalSupply",
                                errorObject: err_5,
                            });
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        // ERC20 Token Contract Write Functions
        /**
         * @dev Approve `receiver` to spend `amount` tokens.
         * @param receiver The receiver approved.
         * @param amount The amount approved.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.approve = function (_a) {
            var receiver = _a.receiver, amount = _a.amount;
            var normalizedReceiver = normalizeAddress(receiver);
            var txn = _this.tokenContract.populateTransaction.approve(normalizedReceiver, amount);
            return new Operation(txn, "ERC20_APPROVE");
        };
        /**
         * @dev Transfer `receiver` `amount` tokens.
         * @param receiver The receiver of the transfer.
         * @param amount The amount to be transferred.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.transfer = function (_a) {
            var receiver = _a.receiver, amount = _a.amount;
            var normalizedReceiver = normalizeAddress(receiver);
            var txn = _this.tokenContract.populateTransaction.transfer(normalizedReceiver, amount);
            return new Operation(txn, "UNSUPPORTED");
        };
        /**
         * @dev Transfer from `sender` to `receiver` `amount` tokens.
         * @param sender The sender of the transfer.
         * @param receiver The receiver of the transfer.
         * @param amount The amount to be transferred.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        this.transferFrom = function (_a) {
            var sender = _a.sender, receiver = _a.receiver, amount = _a.amount;
            var normalizedSender = normalizeAddress(sender);
            var normalizedReceiver = normalizeAddress(receiver);
            var txn = _this.tokenContract.populateTransaction.transferFrom(normalizedSender, normalizedReceiver, amount);
            return new Operation(txn, "ERC20_TRANSFER_FROM");
        };
        this.address = address;
    }
    Object.defineProperty(Token.prototype, "tokenContract", {
        get: function () {
            return new ethers.Contract(this.address, abi);
        },
        enumerable: false,
        configurable: true
    });
    return Token;
}());

/**
 * @dev SuperToken Helper Class
 * @description A helper class to create `SuperToken` objects which can interact with the `SuperToken` contract as well as the CFAV1 and IDAV1 contracts of the desired `SuperToken`.
 */
var SuperToken = /** @class */ (function (_super) {
    __extends(SuperToken, _super);
    function SuperToken(options, settings) {
        var _this = 
        // initialize ERC20 token functions here
        _super.call(this, settings.address) || this;
        // SuperToken Contract Read Functions
        /**
         * @dev Returns the real time balance of `address`.
         * @param account the target address
         * @param timestamp the timestamp you'd like to see the data
         * @param providerOrSigner a provider or signer for executing a web3 call
         * @returns {Promise<IWeb3RealTimeBalanceOf>} real time balance of data
         */
        _this.realtimeBalanceOf = function (_b) {
            var providerOrSigner = _b.providerOrSigner, account = _b.account, _c = _b.timestamp, timestamp = _c === void 0 ? getStringCurrentTimeInSeconds() : _c;
            return __awaiter(_this, void 0, void 0, function () {
                var normalizedAccount, realtimeBalanceOf, err_1;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            normalizedAccount = normalizeAddress(account);
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.superTokenContract
                                    .connect(providerOrSigner)
                                    .realtimeBalanceOf(normalizedAccount, timestamp)];
                        case 2:
                            realtimeBalanceOf = _d.sent();
                            return [2 /*return*/, {
                                    availableBalance: realtimeBalanceOf.availableBalance.toString(),
                                    deposit: realtimeBalanceOf.deposit.toString(),
                                    owedDeposit: realtimeBalanceOf.owedDeposit.toString(),
                                    timestamp: getSanitizedTimestamp(timestamp),
                                }];
                        case 3:
                            err_1 = _d.sent();
                            throw new SFError({
                                type: "SUPERTOKEN_READ",
                                customMessage: "There was an error getting realtimeBalanceOf",
                                errorObject: err_1,
                            });
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        // SuperToken Contract Write Functions
        /**
         * @dev Downgrade `amount` SuperToken's.
         * @param amount The amount to be downgraded.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.downgrade = function (_b) {
            var amount = _b.amount;
            var txn = _this.superTokenContract.populateTransaction.downgrade(amount);
            return new Operation(txn, "SUPERTOKEN_DOWNGRADE");
        };
        /**
         * @dev Upgrade `amount` SuperToken's.
         * @param amount The amount to be upgraded.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.upgrade = function (_b) {
            var amount = _b.amount;
            var txn = _this.superTokenContract.populateTransaction.upgrade(amount);
            return new Operation(txn, "SUPERTOKEN_UPGRADE");
        };
        // CFA Read Functions
        /**
         * @dev Get the details of a flow.
         * @param sender the sender of the flow
         * @param receiver the receiver of the flow
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */
        _this.getFlow = function (_b) {
            var sender = _b.sender, receiver = _b.receiver, providerOrSigner = _b.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.cfaV1.getFlow({
                                superToken: this.settings.address,
                                sender: sender,
                                receiver: receiver,
                                providerOrSigner: providerOrSigner,
                            })];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        /**
         * @dev Get the flow info of an account (net flow).
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3FlowInfo>} Web3 Flow info object
         */
        _this.getAccountFlowInfo = function (_b) {
            var account = _b.account, providerOrSigner = _b.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.cfaV1.getAccountFlowInfo({
                                superToken: this.settings.address,
                                account: account,
                                providerOrSigner: providerOrSigner,
                            })];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        /**
         * @dev Get the net flow of an account.
         * @param account the account we're querying
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<string>} Web3 Flow info object
         */
        _this.getNetFlow = function (_b) {
            var account = _b.account, providerOrSigner = _b.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.cfaV1.getNetFlow({
                                superToken: this.settings.address,
                                account: account,
                                providerOrSigner: providerOrSigner,
                            })];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        // CFA Write Functions
        /**
         * @dev Create a flow of the token of this class.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param flowRate The specified flow rate.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.createFlow = function (_b) {
            var sender = _b.sender, receiver = _b.receiver, flowRate = _b.flowRate, userData = _b.userData;
            return _this.cfaV1.createFlow({
                flowRate: flowRate,
                receiver: receiver,
                sender: sender,
                superToken: _this.settings.address,
                userData: userData,
            });
        };
        /**
         * @dev Update a flow of the token of this class.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param flowRate The specified flow rate.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.updateFlow = function (_b) {
            var sender = _b.sender, receiver = _b.receiver, flowRate = _b.flowRate, userData = _b.userData;
            return _this.cfaV1.updateFlow({
                flowRate: flowRate,
                receiver: receiver,
                sender: sender,
                superToken: _this.settings.address,
                userData: userData,
            });
        };
        /**
         * @dev Delete a flow of the token of this class.
         * @param sender The sender of the flow.
         * @param receiver The receiver of the flow.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.deleteFlow = function (_b) {
            var sender = _b.sender, receiver = _b.receiver, userData = _b.userData;
            return _this.cfaV1.deleteFlow({
                superToken: _this.settings.address,
                sender: sender,
                receiver: receiver,
                userData: userData,
            });
        };
        // IDA Read Functions
        /**
         * @dev Get the details of a `Subscription`.
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param subscriber the subscriber's address
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Subscription>} Web3 Subscription object
         */
        _this.getSubscription = function (_b) {
            var publisher = _b.publisher, indexId = _b.indexId, subscriber = _b.subscriber, providerOrSigner = _b.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.idaV1.getSubscription({
                                superToken: this.settings.address,
                                publisher: publisher,
                                indexId: indexId,
                                subscriber: subscriber,
                                providerOrSigner: providerOrSigner,
                            })];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        /**
         * @dev Get the details of an `Index`.
         * @param publisher the address of the publisher of the index
         * @param indexId the index id
         * @param providerOrSigner a provider or signer object
         * @returns {Promise<IWeb3Index>} Web3 Index object
         */
        _this.getIndex = function (_b) {
            var publisher = _b.publisher, indexId = _b.indexId, providerOrSigner = _b.providerOrSigner;
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.idaV1.getIndex({
                                superToken: this.settings.address,
                                publisher: publisher,
                                indexId: indexId,
                                providerOrSigner: providerOrSigner,
                            })];
                        case 1: return [2 /*return*/, _c.sent()];
                    }
                });
            });
        };
        // IDA Write Functions
        /**
         * @dev Creates an IDA Index.
         * @param indexId The id of the index.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.createIndex = function (_b) {
            var indexId = _b.indexId, userData = _b.userData;
            return _this.idaV1.createIndex({
                indexId: indexId,
                superToken: _this.settings.address,
                userData: userData,
            });
        };
        /**
         * @dev Distributes `amount` of token to an index
         * @param indexId The id of the index.
         * @param amount The amount of tokens to be distributed.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.distribute = function (_b) {
            var indexId = _b.indexId, amount = _b.amount, userData = _b.userData;
            return _this.idaV1.distribute({
                indexId: indexId,
                amount: amount,
                superToken: _this.settings.address,
                userData: userData,
            });
        };
        /**
         * @dev Updates the `IndexValue` field of an index.
         * @param indexId The id of the index.
         * @param indexValue The new indexValue.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         *
         * NOTE: It has the same effect as `distribute`, but is closer to the low level data structure of the index.
         */
        _this.updateIndexValue = function (_b) {
            var indexId = _b.indexId, indexValue = _b.indexValue, userData = _b.userData;
            return _this.idaV1.updateIndexValue({
                indexId: indexId,
                indexValue: indexValue,
                superToken: _this.settings.address,
                userData: userData,
            });
        };
        /**
         * @dev Updates the `units` allocated to a Subscription.
         * @param indexId The id of the index.
         * @param subscriber The subscriber address whose units you want to update.
         * @param units The amount of units you want to update to.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.updateSubscriptionUnits = function (_b) {
            var indexId = _b.indexId, subscriber = _b.subscriber, units = _b.units, userData = _b.userData;
            return _this.idaV1.updateSubscriptionUnits({
                indexId: indexId,
                superToken: _this.settings.address,
                subscriber: subscriber,
                units: units,
                userData: userData,
            });
        };
        /**
         * @dev Approves a Subscription, so the Subscriber won't need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param publisher The publisher address whose subscription you want to approve.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.approveSubscription = function (_b) {
            var indexId = _b.indexId, publisher = _b.publisher, userData = _b.userData;
            return _this.idaV1.approveSubscription({
                indexId: indexId,
                superToken: _this.settings.address,
                publisher: publisher,
                userData: userData,
            });
        };
        /**
         * @dev Revokes a Subscription, so the Subscriber will need to claim tokens when the Publisher distributes.
         * @param indexId The id of the index.
         * @param publisher The index publisher address you want to revoke for the subscriber.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.revokeSubscription = function (_b) {
            var indexId = _b.indexId, publisher = _b.publisher, userData = _b.userData;
            return _this.idaV1.revokeSubscription({
                indexId: indexId,
                superToken: _this.settings.address,
                publisher: publisher,
                userData: userData,
            });
        };
        /**
         * @dev Deletes a Subscription by setting the `units` allocated to the Subscriber to 0.
         * @param indexId The id of the index.
         * @param subscriber The subscriber address whose subscription you want to delete.
         * @param publisher The publisher address of the index you are targeting.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.deleteSubscription = function (_b) {
            var indexId = _b.indexId, subscriber = _b.subscriber, publisher = _b.publisher, userData = _b.userData;
            return _this.idaV1.deleteSubscription({
                indexId: indexId,
                superToken: _this.settings.address,
                subscriber: subscriber,
                publisher: publisher,
                userData: userData,
            });
        };
        /**
         * @dev Claims any pending tokens allocated to the Subscription (unapproved).
         * @param indexId The id of the index.
         * @param subscriber The subscriber address who you are claiming for.
         * @param publisher The publisher address of the index you are targeting.
         * @param userData Extra user data provided.
         * @returns {Operation} An instance of Operation which can be executed or batched.
         */
        _this.claim = function (_b) {
            var indexId = _b.indexId, subscriber = _b.subscriber, publisher = _b.publisher, userData = _b.userData;
            return _this.idaV1.claim({
                indexId: indexId,
                superToken: _this.settings.address,
                subscriber: subscriber,
                publisher: publisher,
                userData: userData,
            });
        };
        _this.options = options;
        _this.settings = settings;
        _this.cfaV1 = new ConstantFlowAgreementV1({
            config: _this.settings.config,
        });
        _this.idaV1 = new InstantDistributionAgreementV1({
            config: _this.settings.config,
        });
        _this.underlyingToken = new Token(settings.underlyingTokenAddress);
        return _this;
    }
    Object.defineProperty(SuperToken.prototype, "superTokenContract", {
        get: function () {
            return new ethers.Contract(this.settings.address, abi$1);
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    _a = SuperToken;
    SuperToken.create = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var networkName, chainId, superToken, underlyingTokenAddress, settings, err_2;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!options.chainId && !options.networkName) {
                        throw new SFError({
                            type: "SUPERTOKEN_INITIALIZATION",
                            customMessage: "You must input chainId or networkName.",
                        });
                    }
                    networkName = getNetworkName(options);
                    chainId = options.chainId || networkNameToChainIdMap.get(networkName);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    superToken = new ethers.Contract(options.address, abi$1);
                    return [4 /*yield*/, superToken
                            .connect(options.provider)
                            .getUnderlyingToken()];
                case 2:
                    underlyingTokenAddress = _b.sent();
                    settings = {
                        address: options.address,
                        config: options.config,
                        chainId: chainId,
                        networkName: networkName,
                        underlyingTokenAddress: underlyingTokenAddress,
                    };
                    return [2 /*return*/, new SuperToken(options, settings)];
                case 3:
                    err_2 = _b.sent();
                    throw new SFError({
                        type: "SUPERTOKEN_INITIALIZATION",
                        customMessage: "There was an error initializing the SuperToken",
                        errorObject: err_2,
                    });
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return SuperToken;
}(Token));

var GetIndexesDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getIndexes" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Index_filter" } } }, "defaultValue": { "kind": "ObjectValue", "fields": [] } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "0" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "10" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Index_orderBy" } } }, "defaultValue": { "kind": "EnumValue", "value": "id" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "OrderDirection" } } }, "defaultValue": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "result" }, "name": { "kind": "Name", "value": "indexes" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "skip" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexValue" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalSubscriptionsWithUnits" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalUnitsPending" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalUnitsApproved" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalUnits" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalAmountDistributedUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isListed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "underlyingAddress" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }] } }] };

var ajv = new Ajv();
ajv.addFormat("addressOrEmpty", {
    type: "string",
    validate: function (x) { return x === "" || ethers.utils.isAddress(x); },
});
ajv.addFormat("stringNumber", {
    type: "string",
    validate: function (x) { return !isNaN(Number(x)); },
});
// Schemas
var superTokenRequestSchema = {
    type: "object",
    additionalProperties: false,
    properties: {
        isListed: { type: "boolean", nullable: true },
    },
};
var eventRequestSchema = {
    type: "object",
    additionalProperties: false,
    properties: {
        account: { type: "string", format: "addressOrEmpty", nullable: true },
        timestamp_gt: {
            type: "number",
            nullable: true,
        },
    },
};
var indexRequestSchema = {
    type: "object",
    additionalProperties: false,
    properties: {
        indexId: { type: "string", format: "stringNumber", nullable: true },
        publisher: { type: "string", format: "addressOrEmpty", nullable: true },
        token: { type: "string", format: "addressOrEmpty", nullable: true },
    },
};
var accountTokenSnapshotRequestSchema = {
    type: "object",
    additionalProperties: false,
    properties: {
        account: {
            type: "string",
            format: "addressOrEmpty",
            nullable: true,
        },
        token: { type: "string", format: "addressOrEmpty", nullable: true },
    },
};
var indexSubscriptionRequestSchema = {
    type: "object",
    additionalProperties: false,
    properties: {
        subscriber: {
            type: "string",
            format: "stringNumber",
            nullable: true,
        },
        approved: { type: "boolean", nullable: true },
    },
};
var streamRequestSchema = {
    type: "object",
    additionalProperties: false,
    properties: {
        sender: { type: "string", format: "addressOrEmpty", nullable: true },
        receiver: { type: "string", format: "addressOrEmpty", nullable: true },
        token: { type: "string", format: "addressOrEmpty", nullable: true },
    },
};
function wrapValidationWithCustomError(validateFunction) {
    return function (filter) {
        if (!validateFunction(filter)) {
            throw new SFError({
                type: "INVALID_OBJECT",
                customMessage: "Invalid Filter Object",
                errorObject: validateFunction.errors,
            });
        }
    };
}
// Validate functions
var validateSuperTokenRequest = wrapValidationWithCustomError(ajv.compile(superTokenRequestSchema));
var validateEventRequest = wrapValidationWithCustomError(ajv.compile(eventRequestSchema));
var validateIndexRequest = wrapValidationWithCustomError(ajv.compile(indexRequestSchema));
var validateIndexSubscriptionRequest = wrapValidationWithCustomError(ajv.compile(indexSubscriptionRequestSchema));
var validateStreamRequest = wrapValidationWithCustomError(ajv.compile(streamRequestSchema));
var validateAccountTokenSnapshotRequest = wrapValidationWithCustomError(ajv.compile(accountTokenSnapshotRequestSchema));

/**
 * Factory function to create a {@link PagedResult}.
 * @param dataPlusOne Subgraph queries are executed with one extra result to get which is over the {@link Paging} `take` amount.
 * @param paging
 */
var createPagedResult = function (dataPlusOne, paging) {
    var _a;
    var hasNextPage = dataPlusOne.length > paging.take;
    var data = dataPlusOne.slice(0, paging.take);
    var lastId = (_a = data.slice(-1)[0]) === null || _a === void 0 ? void 0 : _a.id;
    return {
        paging: { skip: paging.skip, take: paging.take },
        nextPaging: hasNextPage
            ? isSkipPaging(paging)
                ? nextSkipPaging(paging)
                : nextLastIdPaging(paging, lastId)
            : undefined,
        data: data,
    };
};
function isSkipPaging(paging) {
    return paging.skip !== undefined;
}
var createSkipPaging = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.skip, skip = _c === void 0 ? 0 : _c, _d = _b.take, take = _d === void 0 ? 100 : _d;
    return ({
        skip: skip,
        take: take
    });
};
var createLastIdPaging = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.lastId, lastId = _c === void 0 ? "" : _c, _d = _b.take, take = _d === void 0 ? 100 : _d;
    return ({
        take: take,
        lastId: lastId
    });
};
/**
 * @dev Gets the next page given the skip/take used to initialize the `PagedResult` interface.
 * @returns the `Paging` class with the next page
 */
var nextSkipPaging = function (paging) { return ({
    skip: paging.skip + paging.take,
    take: paging.take,
}); };
var nextLastIdPaging = function (paging, nextLastId) { return ({
    take: paging.take,
    lastId: nextLastId,
}); };
/**
 * @dev Used to determine whether there is another page for pagination.
 * @returns the user's specified `take` plus one
 */
var takePlusOne = function (paging) {
    return paging.take + 1;
};

var SubgraphClient = /** @class */ (function () {
    function SubgraphClient(subgraphUrl) {
        this.subgraphUrl = subgraphUrl;
    }
    SubgraphClient.prototype.request = function (document, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, request(this.subgraphUrl, document, cleanVariables(variables))];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        throw new SFError({
                            type: "SUBGRAPH_ERROR",
                            customMessage: "Failed call to subgraph with query ".concat(document),
                            errorObject: err_1,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SubgraphClient.prototype.batchRequests = function (documents) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, batchRequests(this.subgraphUrl, documents)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_2 = _a.sent();
                        throw new SFError({
                            type: "SUBGRAPH_ERROR",
                            customMessage: "Failed call to subgraph with query...",
                            errorObject: err_2,
                        });
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return SubgraphClient;
}());
// Inspired by: https://stackoverflow.com/a/38340730
// Remove properties with null, undefined, empty string values.
function cleanVariables(variables) {
    return Object.fromEntries(Object.entries(variables)
        .filter(function (_a) {
        _a[0]; var value = _a[1];
        return value !== "" && value !== null && value !== undefined;
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return [
            key,
            value === Object(value) && !Array.isArray(value)
                ? cleanVariables(value)
                : value,
        ];
    }));
}

var GetTokensDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getTokens" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Token_filter" } } }, "defaultValue": { "kind": "ObjectValue", "fields": [] } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "0" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "10" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Token_orderBy" } } }, "defaultValue": { "kind": "EnumValue", "value": "id" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "OrderDirection" } } }, "defaultValue": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "result" }, "name": { "kind": "Name", "value": "tokens" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "skip" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isListed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "underlyingAddress" } }] } }] } }] };

var GetIndexSubscriptionsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getIndexSubscriptions" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexSubscription_filter" } } }, "defaultValue": { "kind": "ObjectValue", "fields": [] } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "0" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "10" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexSubscription_orderBy" } } }, "defaultValue": { "kind": "EnumValue", "value": "id" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "OrderDirection" } } }, "defaultValue": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "result" }, "name": { "kind": "Name", "value": "indexSubscriptions" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "skip" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "approved" } }, { "kind": "Field", "name": { "kind": "Name", "value": "units" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalAmountReceivedUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexValueUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexValue" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isListed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "underlyingAddress" } }] } }] } }] } }] } }] };

var GetStreamsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getStreams" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Stream_filter" } } }, "defaultValue": { "kind": "ObjectValue", "fields": [] } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "0" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "10" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Stream_orderBy" } } }, "defaultValue": { "kind": "EnumValue", "value": "id" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "OrderDirection" } } }, "defaultValue": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "result" }, "name": { "kind": "Name", "value": "streams" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "skip" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "currentFlowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "streamedUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isListed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "underlyingAddress" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "sender" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "receiver" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "flowUpdatedEvents" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "EnumValue", "value": "timestamp" } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "blockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transactionHash" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sender" } }, { "kind": "Field", "name": { "kind": "Name", "value": "receiver" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalSenderFlowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalReceiverFlowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "oldFlowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalAmountStreamedUntilTimestamp" } }] } }] } }] } }] };

var GetAccountTokenSnapshotsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getAccountTokenSnapshots" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "AccountTokenSnapshot_filter" } } }, "defaultValue": { "kind": "ObjectValue", "fields": [] } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "0" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "10" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "AccountTokenSnapshot_orderBy" } } }, "defaultValue": { "kind": "EnumValue", "value": "id" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "OrderDirection" } } }, "defaultValue": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "result" }, "name": { "kind": "Name", "value": "accountTokenSnapshots" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "skip" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalNumberOfActiveStreams" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalNumberOfClosedStreams" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalSubscriptionsWithUnits" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalApprovedSubscriptions" } }, { "kind": "Field", "name": { "kind": "Name", "value": "balanceUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalNetFlowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalInflowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalOutflowRate" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalAmountStreamedUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalAmountTransferredUntilUpdatedAt" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtTimestamp" } }, { "kind": "Field", "name": { "kind": "Name", "value": "createdAtBlockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "symbol" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isListed" } }, { "kind": "Field", "name": { "kind": "Name", "value": "underlyingAddress" } }] } }] } }] } }] };

var EventFieldsFragmentDoc = { "kind": "Document", "definitions": [{ "kind": "FragmentDefinition", "name": { "kind": "Name", "value": "eventFields" }, "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "Event" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "__typename" } }, { "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "blockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "transactionHash" } }, { "kind": "Field", "name": { "kind": "Name", "value": "timestamp" } }] } }] };
var GetAllEventsDocument = { "kind": "Document", "definitions": __spreadArray([{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "getAllEvents" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Event_filter" } } }, "defaultValue": { "kind": "ObjectValue", "fields": [] } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "0" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Int" } } }, "defaultValue": { "kind": "IntValue", "value": "10" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Event_orderBy" } } }, "defaultValue": { "kind": "EnumValue", "value": "id" } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "OrderDirection" } } }, "defaultValue": { "kind": "EnumValue", "value": "asc" } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "events" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "where" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "skip" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "skip" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "first" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "first" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderBy" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "orderDirection" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "orderDirection" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "FlowUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sender" } }, { "kind": "Field", "name": { "kind": "Name", "value": "receiver" } }, { "kind": "Field", "name": { "kind": "Name", "value": "flowRate" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexCreatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexDistributionClaimedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalUnitsPending" } }, { "kind": "Field", "name": { "kind": "Name", "value": "totalUnitsApproved" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "oldIndexValue" } }, { "kind": "Field", "name": { "kind": "Name", "value": "newIndexValue" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexSubscribedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexUnitsUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "units" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "oldUnits" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "IndexUnsubscribedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "index" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SubscriptionApprovedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscription" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SubscriptionDistributionClaimedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscription" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SubscriptionRevokedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscription" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SubscriptionUnitsUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "units" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscription" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "publisher" } }, { "kind": "Field", "name": { "kind": "Name", "value": "oldUnits" } }, { "kind": "Field", "name": { "kind": "Name", "value": "indexId" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "TransferEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "value" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "to" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "from" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "TokenUpgradedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "TokenDowngradedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "blockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }] } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "AgreementClassRegisteredEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "code" } }, { "kind": "Field", "name": { "kind": "Name", "value": "agreementType" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "AgreementClassUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "code" } }, { "kind": "Field", "name": { "kind": "Name", "value": "agreementType" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "AppRegisteredEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "blockNumber" } }, { "kind": "Field", "name": { "kind": "Name", "value": "app" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "GovernanceReplacedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "oldGovernance" } }, { "kind": "Field", "name": { "kind": "Name", "value": "newGovernance" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "JailEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "app" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SuperTokenFactoryUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "newFactory" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SuperTokenLogicUpdatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "code" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "RoleAdminChangedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "role" } }, { "kind": "Field", "name": { "kind": "Name", "value": "previousAdminRole" } }, { "kind": "Field", "name": { "kind": "Name", "value": "newAdminRole" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "RoleGrantedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sender" } }, { "kind": "Field", "name": { "kind": "Name", "value": "role" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "RoleRevokedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "sender" } }, { "kind": "Field", "name": { "kind": "Name", "value": "role" } }, { "kind": "Field", "name": { "kind": "Name", "value": "account" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "CFAv1LiquidationPeriodChangedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "superToken" } }, { "kind": "Field", "name": { "kind": "Name", "value": "host" } }, { "kind": "Field", "name": { "kind": "Name", "value": "liquidationPeriod" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isSet" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "ConfigChangedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "value" } }, { "kind": "Field", "name": { "kind": "Name", "value": "superToken" } }, { "kind": "Field", "name": { "kind": "Name", "value": "key" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isSet" } }, { "kind": "Field", "name": { "kind": "Name", "value": "host" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "RewardAddressChangedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "superToken" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rewardAddress" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isSet" } }, { "kind": "Field", "name": { "kind": "Name", "value": "host" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "TrustedForwarderChangedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "isSet" } }, { "kind": "Field", "name": { "kind": "Name", "value": "host" } }, { "kind": "Field", "name": { "kind": "Name", "value": "forwarder" } }, { "kind": "Field", "name": { "kind": "Name", "value": "enabled" } }, { "kind": "Field", "name": { "kind": "Name", "value": "superToken" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "AgreementLiquidatedByEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "rewardAmount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "penaltyAccount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "liquidatorAccount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bondAccount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "bailoutAmount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "agreementId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "agreementClass" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "BurnedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "operatorData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "operator" } }, { "kind": "Field", "name": { "kind": "Name", "value": "from" } }, { "kind": "Field", "name": { "kind": "Name", "value": "data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "MintedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "operatorData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "operator" } }, { "kind": "Field", "name": { "kind": "Name", "value": "data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }, { "kind": "Field", "name": { "kind": "Name", "value": "to" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SentEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "to" } }, { "kind": "Field", "name": { "kind": "Name", "value": "operatorData" } }, { "kind": "Field", "name": { "kind": "Name", "value": "operator" } }, { "kind": "Field", "name": { "kind": "Name", "value": "data" } }, { "kind": "Field", "name": { "kind": "Name", "value": "amount" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "CustomSuperTokenCreatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SuperTokenCreatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "token" } }] } }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "SuperTokenLogicCreatedEvent" } }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "FragmentSpread", "name": { "kind": "Name", "value": "eventFields" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tokenLogic" } }] } }] } }] } }], EventFieldsFragmentDoc.definitions, true) };

// Why? Because `return obj as T` and `return <T>obj` are not safe type casts.
var typeGuard$1 = function (obj) { return obj; };
var mapGetAllEventsQueryEvents = function (queryResponse) {
    return queryResponse.events.map(function (x) {
        switch (x.__typename) {
            case "AppRegisteredEvent":
                return typeGuard$1({
                    name: "AppRegistered",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    app: x.app,
                });
            case "AgreementClassRegisteredEvent":
                return typeGuard$1({
                    name: "AgreementClassRegistered",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    agreementType: x.agreementType,
                    code: x.code,
                });
            case "AgreementClassUpdatedEvent":
                return typeGuard$1({
                    name: "AgreementClassUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    agreementType: x.agreementType,
                    code: x.code,
                });
            case "AgreementLiquidatedByEvent":
                return typeGuard$1({
                    name: "AgreementLiquidatedBy",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    agreementClass: x.agreementClass,
                    agreementId: x.agreementId,
                    bailoutAmount: x.bailoutAmount,
                    bondAccount: x.bondAccount,
                    liquidatorAccount: x.liquidatorAccount,
                    penaltyAccount: x.penaltyAccount,
                    rewardAmount: x.rewardAmount,
                    token: x.token,
                });
            case "BurnedEvent":
                return typeGuard$1({
                    name: "Burned",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    amount: x.amount,
                    data: x.data,
                    from: x.from,
                    operator: x.operator,
                    operatorData: x.operatorData,
                });
            case "CFAv1LiquidationPeriodChangedEvent":
                return typeGuard$1({
                    name: "CFAv1LiquidationPeriodChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    host: x.host,
                    isSet: x.isSet,
                    liquidationPeriod: Number(x.liquidationPeriod),
                    superToken: x.superToken,
                });
            case "ConfigChangedEvent":
                return typeGuard$1({
                    name: "ConfigChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    host: x.host,
                    isSet: x.isSet,
                    key: x.key,
                    superToken: x.superToken,
                    value: x.value,
                });
            case "CustomSuperTokenCreatedEvent":
                return typeGuard$1({
                    name: "CustomSuperTokenCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                });
            case "FlowUpdatedEvent":
                return typeGuard$1({
                    name: "FlowUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    flowRate: x.flowRate,
                    receiver: x.receiver,
                    sender: x.sender,
                });
            case "GovernanceReplacedEvent":
                return typeGuard$1({
                    name: "GovernanceReplaced",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    oldGovernance: x.oldGovernance,
                    newGovernance: x.newGovernance,
                });
            case "IndexCreatedEvent":
                return typeGuard$1({
                    name: "IndexCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    userData: x.userData,
                });
            case "IndexDistributionClaimedEvent":
                return typeGuard$1({
                    name: "IndexDistributionClaimed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    amount: x.amount,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber,
                });
            case "IndexSubscribedEvent":
                return typeGuard$1({
                    name: "IndexSubscribed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber,
                });
            case "IndexUnitsUpdatedEvent":
                return typeGuard$1({
                    name: "IndexUnitsUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber,
                    units: x.units,
                    oldUnits: x.oldUnits,
                    userData: x.userData,
                });
            case "IndexUnsubscribedEvent":
                return typeGuard$1({
                    name: "IndexUnsubscribed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    indexId: x.indexId,
                    publisher: x.publisher,
                    subscriber: x.subscriber,
                    userData: x.userData,
                });
            case "IndexUpdatedEvent":
                return typeGuard$1({
                    name: "IndexUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    indexId: x.indexId,
                    newIndexValue: x.newIndexValue,
                    oldIndexValue: x.oldIndexValue,
                    publisher: x.publisher,
                    totalUnitsApproved: x.totalUnitsApproved,
                    totalUnitsPending: x.totalUnitsPending,
                    userData: x.userData,
                });
            case "JailEvent":
                return typeGuard$1({
                    name: "Jail",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    app: x.app,
                    reason: x.reason,
                });
            case "MintedEvent":
                return typeGuard$1({
                    name: "Minted",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    operator: x.operator,
                    to: x.to,
                    amount: x.amount,
                    data: x.data,
                    operatorData: x.operatorData,
                });
            case "RewardAddressChangedEvent":
                return typeGuard$1({
                    name: "RewardAddressChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    host: x.host,
                    superToken: x.superToken,
                    isSet: x.isSet,
                    rewardAddress: x.rewardAddress,
                });
            case "RoleAdminChangedEvent":
                return typeGuard$1({
                    name: "RoleAdminChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    role: x.role,
                    previousAdminRole: x.previousAdminRole,
                    newAdminRole: x.newAdminRole,
                });
            case "RoleGrantedEvent":
                return typeGuard$1({
                    name: "RoleGranted",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    role: x.role,
                    account: x.account,
                    sender: x.sender,
                });
            case "RoleRevokedEvent":
                return typeGuard$1({
                    name: "RoleRevoked",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    role: x.role,
                    account: x.account,
                    sender: x.sender,
                });
            case "SentEvent":
                return typeGuard$1({
                    name: "Sent",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    operator: x.operator,
                    to: x.to,
                    amount: x.amount,
                    data: x.data,
                    operatorData: x.operatorData,
                });
            case "SubscriptionApprovedEvent":
                return typeGuard$1({
                    name: "SubscriptionApproved",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    userData: x.userData,
                    subscription: x.subscription.id,
                });
            case "SubscriptionDistributionClaimedEvent":
                return typeGuard$1({
                    name: "SubscriptionDistributionClaimed",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    amount: x.amount,
                    subscription: x.subscription.id,
                });
            case "SubscriptionRevokedEvent":
                return typeGuard$1({
                    name: "SubscriptionRevoked",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    userData: x.userData,
                    subscription: x.subscription.id,
                });
            case "SubscriptionUnitsUpdatedEvent":
                return typeGuard$1({
                    name: "SubscriptionUnitsUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    subscriber: x.subscriber,
                    publisher: x.publisher,
                    indexId: x.indexId,
                    units: x.units,
                    userData: x.userData,
                    subscription: x.subscription.id,
                });
            case "SuperTokenCreatedEvent":
                return typeGuard$1({
                    name: "SuperTokenCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                });
            case "SuperTokenFactoryUpdatedEvent":
                return typeGuard$1({
                    name: "SuperTokenFactoryUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    newFactory: x.newFactory,
                });
            case "SuperTokenLogicCreatedEvent":
                return typeGuard$1({
                    name: "SuperTokenLogicCreated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    tokenLogic: x.tokenLogic,
                });
            case "SuperTokenLogicUpdatedEvent":
                return typeGuard$1({
                    name: "SuperTokenLogicUpdated",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    token: x.token,
                    code: x.code,
                });
            case "TokenDowngradedEvent":
                return typeGuard$1({
                    name: "TokenDowngraded",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    amount: x.amount,
                    token: x.token,
                    account: x.account.id,
                });
            case "TokenUpgradedEvent":
                return typeGuard$1({
                    name: "TokenUpgraded",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    amount: x.amount,
                    token: x.token,
                    account: x.account.id,
                });
            case "TransferEvent":
                return typeGuard$1({
                    name: "Transfer",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    from: x.from.id,
                    to: x.to.id,
                    token: x.token,
                    value: x.value,
                });
            case "TrustedForwarderChangedEvent":
                return typeGuard$1({
                    name: "TrustedForwarderChanged",
                    id: x.id,
                    blockNumber: Number(x.blockNumber),
                    transactionHash: x.transactionHash,
                    timestamp: Number(x.timestamp),
                    host: x.host,
                    superToken: x.superToken,
                    isSet: x.isSet,
                    forwarder: x.forwarder,
                    enabled: x.enabled,
                });
            default:
                throw Error("Unknown error.");
        }
    });
};

/**
 * @dev Query Helper Class
 * @description A helper class to create `Query` objects which can be used to query different data.
 */
var Query = /** @class */ (function () {
    function Query(options) {
        var _this = this;
        /**
         * A recursive function to fetch all possible results of a paged query.
         * @param pagedQuery A paginated query that takes {@link Paging} as input.
         */
        this.listAllResults = function (pagedQuery) { return __awaiter(_this, void 0, void 0, function () {
            var listAllRecursively;
            var _this = this;
            return __generator(this, function (_a) {
                listAllRecursively = function (paging) { return __awaiter(_this, void 0, void 0, function () {
                    var pagedResult, nextResults;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, pagedQuery(paging)];
                            case 1:
                                pagedResult = _a.sent();
                                if (!pagedResult.nextPaging)
                                    return [2 /*return*/, pagedResult.data];
                                return [4 /*yield*/, listAllRecursively(pagedResult.nextPaging)];
                            case 2:
                                nextResults = _a.sent();
                                return [2 /*return*/, pagedResult.data.concat(nextResults)];
                        }
                    });
                }); };
                return [2 /*return*/, listAllRecursively(createLastIdPaging({ take: 999 }))];
            });
        }); };
        this.listAllSuperTokens = function (filter, paging, ordering) {
            if (paging === void 0) { paging = createSkipPaging(); }
            if (ordering === void 0) { ordering = {
                orderBy: "createdAtBlockNumber",
                orderDirection: "desc"
            }; }
            return __awaiter(_this, void 0, void 0, function () {
                var response, mappedResult;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.dataMode === "WEB3_ONLY") {
                                throw new SFError({
                                    type: "UNSUPPORTED_WEB_3_ONLY",
                                    customMessage: "This query is not supported in WEB3_ONLY mode.",
                                });
                            }
                            validateSuperTokenRequest(filter);
                            return [4 /*yield*/, this.subgraphClient.request(GetTokensDocument, {
                                    where: {
                                        isListed: filter.isListed,
                                        isSuperToken: true,
                                        id_gt: paging.lastId,
                                    },
                                    orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                                    orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                                    first: takePlusOne(paging),
                                    skip: paging.skip,
                                })];
                        case 1:
                            response = _a.sent();
                            mappedResult = response.result.map(function (x) {
                                return typeGuard(__assign(__assign({}, x), { createdAtTimestamp: Number(x.createdAtTimestamp), createdAtBlockNumber: Number(x.createdAtBlockNumber) }));
                            });
                            return [2 /*return*/, createPagedResult(mappedResult, paging)];
                    }
                });
            });
        };
        this.listIndexes = function (filter, paging, ordering) {
            if (paging === void 0) { paging = createSkipPaging(); }
            if (ordering === void 0) { ordering = {
                orderBy: "createdAtBlockNumber",
                orderDirection: "desc"
            }; }
            return __awaiter(_this, void 0, void 0, function () {
                var response, mappedResult;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (this.options.dataMode === "WEB3_ONLY") {
                                throw new SFError({
                                    type: "UNSUPPORTED_WEB_3_ONLY",
                                    customMessage: "This query is not supported in WEB3_ONLY mode.",
                                });
                            }
                            validateIndexRequest(filter);
                            return [4 /*yield*/, this.subgraphClient.request(GetIndexesDocument, {
                                    where: {
                                        indexId: filter.indexId,
                                        publisher: (_a = filter.publisher) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                                        token: (_b = filter.token) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                                        id_gt: paging.lastId,
                                    },
                                    orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                                    orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                                    first: takePlusOne(paging),
                                    skip: paging.skip,
                                })];
                        case 1:
                            response = _c.sent();
                            mappedResult = response.result.map(function (x) {
                                return typeGuard(__assign(__assign({}, x), { publisher: x.publisher.id, createdAtTimestamp: Number(x.createdAtTimestamp), createdAtBlockNumber: Number(x.createdAtBlockNumber), updatedAtTimestamp: Number(x.updatedAtTimestamp), updatedAtBlockNumber: Number(x.updatedAtBlockNumber), token: __assign(__assign({}, x.token), { createdAtTimestamp: Number(x.token.createdAtTimestamp), createdAtBlockNumber: Number(x.token.createdAtBlockNumber) }) }));
                            });
                            return [2 /*return*/, createPagedResult(mappedResult, paging)];
                    }
                });
            });
        };
        this.listIndexSubscriptions = function (filter, paging, ordering) {
            if (paging === void 0) { paging = createSkipPaging(); }
            if (ordering === void 0) { ordering = {
                orderBy: "createdAtBlockNumber",
                orderDirection: "desc"
            }; }
            return __awaiter(_this, void 0, void 0, function () {
                var response, mappedResult;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this.options.dataMode === "WEB3_ONLY") {
                                throw new SFError({
                                    type: "UNSUPPORTED_WEB_3_ONLY",
                                    customMessage: "This query is not supported in WEB3_ONLY mode.",
                                });
                            }
                            validateIndexSubscriptionRequest(filter);
                            return [4 /*yield*/, this.subgraphClient.request(GetIndexSubscriptionsDocument, {
                                    where: {
                                        subscriber: (_a = filter.subscriber) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                                        approved: filter.approved,
                                        id_gt: paging.lastId,
                                    },
                                    orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                                    orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                                    first: takePlusOne(paging),
                                    skip: paging.skip,
                                })];
                        case 1:
                            response = _b.sent();
                            mappedResult = response.result.map(function (x) {
                                return typeGuard(__assign(__assign({}, x), { subscriber: x.subscriber.id, createdAtTimestamp: Number(x.createdAtTimestamp), createdAtBlockNumber: Number(x.createdAtBlockNumber), updatedAtTimestamp: Number(x.updatedAtTimestamp), updatedAtBlockNumber: Number(x.updatedAtBlockNumber), index: __assign(__assign({}, x.index), { token: __assign(__assign({}, x.index.token), { createdAtTimestamp: Number(x.index.token.createdAtTimestamp), createdAtBlockNumber: Number(x.index.token.createdAtBlockNumber) }) }) }));
                            });
                            return [2 /*return*/, createPagedResult(mappedResult, paging)];
                    }
                });
            });
        };
        this.listStreams = function (filter, paging, ordering) {
            if (paging === void 0) { paging = createSkipPaging(); }
            if (ordering === void 0) { ordering = {
                orderBy: "createdAtBlockNumber",
                orderDirection: "desc"
            }; }
            return __awaiter(_this, void 0, void 0, function () {
                var response, mappedResult;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (this.options.dataMode === "WEB3_ONLY") {
                                throw new SFError({
                                    type: "UNSUPPORTED_WEB_3_ONLY",
                                    customMessage: "This query is not supported in WEB3_ONLY mode.",
                                });
                            }
                            validateStreamRequest(filter);
                            return [4 /*yield*/, this.subgraphClient.request(GetStreamsDocument, {
                                    where: {
                                        sender: (_a = filter.sender) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                                        receiver: (_b = filter.receiver) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                                        token: (_c = filter.token) === null || _c === void 0 ? void 0 : _c.toLowerCase(),
                                        id_gt: paging.lastId,
                                    },
                                    orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                                    orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                                    first: takePlusOne(paging),
                                    skip: paging.skip,
                                })];
                        case 1:
                            response = _d.sent();
                            mappedResult = response.result.map(function (x) {
                                return typeGuard(__assign(__assign({}, x), { sender: x.sender.id, receiver: x.receiver.id, createdAtTimestamp: Number(x.createdAtTimestamp), createdAtBlockNumber: Number(x.createdAtBlockNumber), updatedAtTimestamp: Number(x.updatedAtTimestamp), updatedAtBlockNumber: Number(x.updatedAtBlockNumber), token: __assign(__assign({}, x.token), { createdAtTimestamp: Number(x.token.createdAtTimestamp), createdAtBlockNumber: Number(x.token.createdAtBlockNumber) }), flowUpdatedEvents: x.flowUpdatedEvents.map(function (y) { return (__assign(__assign({}, y), { blockNumber: Number(y.blockNumber), timestamp: Number(y.timestamp) })); }) }));
                            });
                            return [2 /*return*/, createPagedResult(mappedResult, paging)];
                    }
                });
            });
        };
        this.listUserInteractedSuperTokens = function (filter, paging, ordering) {
            if (paging === void 0) { paging = createSkipPaging(); }
            if (ordering === void 0) { ordering = {
                orderBy: "updatedAtBlockNumber",
                orderDirection: "desc"
            }; }
            return __awaiter(_this, void 0, void 0, function () {
                var response, mappedResult;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (this.options.dataMode === "WEB3_ONLY") {
                                throw new SFError({
                                    type: "UNSUPPORTED_WEB_3_ONLY",
                                    customMessage: "This query is not supported in WEB3_ONLY mode.",
                                });
                            }
                            validateAccountTokenSnapshotRequest(filter);
                            return [4 /*yield*/, this.subgraphClient.request(GetAccountTokenSnapshotsDocument, {
                                    where: {
                                        account: (_a = filter.account) === null || _a === void 0 ? void 0 : _a.toLowerCase(),
                                        token: (_b = filter.token) === null || _b === void 0 ? void 0 : _b.toLowerCase(),
                                        id_gt: paging.lastId,
                                    },
                                    orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                                    orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                                    first: takePlusOne(paging),
                                    skip: paging.skip,
                                })];
                        case 1:
                            response = _c.sent();
                            mappedResult = response.result.map(function (x) {
                                return typeGuard(__assign(__assign({}, x), { account: x.account.id, updatedAtTimestamp: Number(x.updatedAtTimestamp), updatedAtBlockNumber: Number(x.updatedAtBlockNumber), token: __assign(__assign({}, x.token), { createdAtTimestamp: Number(x.token.createdAtTimestamp), createdAtBlockNumber: Number(x.token.createdAtBlockNumber) }) }));
                            });
                            return [2 /*return*/, createPagedResult(mappedResult, paging)];
                    }
                });
            });
        };
        this.listEvents = function (filter, paging, ordering) {
            if (paging === void 0) { paging = createSkipPaging(); }
            if (ordering === void 0) { ordering = {
                orderBy: "blockNumber",
                orderDirection: "desc",
            }; }
            return __awaiter(_this, void 0, void 0, function () {
                var response;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (this.options.dataMode === "WEB3_ONLY") {
                                throw new SFError({
                                    type: "UNSUPPORTED_WEB_3_ONLY",
                                    customMessage: "This query is not supported in WEB3_ONLY mode.",
                                });
                            }
                            validateEventRequest(filter);
                            return [4 /*yield*/, this.subgraphClient.request(GetAllEventsDocument, {
                                    orderBy: ordering === null || ordering === void 0 ? void 0 : ordering.orderBy,
                                    orderDirection: ordering === null || ordering === void 0 ? void 0 : ordering.orderDirection,
                                    where: {
                                        addresses_contains: filter.account
                                            ? [(_a = filter.account) === null || _a === void 0 ? void 0 : _a.toLowerCase()]
                                            : undefined,
                                        timestamp_gt: (_b = filter.timestamp_gt) === null || _b === void 0 ? void 0 : _b.toString(),
                                        id_gt: paging.lastId,
                                    },
                                    first: takePlusOne(paging),
                                    skip: paging.skip,
                                })];
                        case 1:
                            response = _c.sent();
                            return [2 /*return*/, createPagedResult(mapGetAllEventsQueryEvents(response), paging)];
                    }
                });
            });
        };
        this.options = options;
        this.subgraphClient = new SubgraphClient(this.options.customSubgraphQueriesEndpoint);
    }
    // TODO(KK): error callback?
    // TODO(KK): retries?
    // TODO(KK): tests
    Query.prototype.on = function (callback, ms, account, timeout) {
        var _this = this;
        if (ms < 1000)
            throw Error("Let's not go crazy with the queries...");
        // Account for the fact that Subgraph has lag and will insert events with the timestamp of the event from blockchain.
        var clockSkew = 25000;
        // Convert millisecond-based time to second-based time (which Subgraph uses).
        var eventQueryTimestamp = Math.floor((new Date().getTime() - clockSkew) / 1000);
        var isUnsubscribed = false;
        var unsubscribe = function () {
            isUnsubscribed = true;
        };
        var pollingStep = function () { return __awaiter(_this, void 0, void 0, function () {
            var allEvents, lastEvent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isUnsubscribed) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.listAllResults(function (paging) { return _this.listEvents({
                                account: account,
                                timestamp_gt: eventQueryTimestamp,
                            }, paging, {
                                orderBy: "timestamp",
                                orderDirection: "asc"
                            }); })];
                    case 1:
                        allEvents = _a.sent();
                        if (allEvents.length) {
                            callback(allEvents, unsubscribe);
                            lastEvent = allEvents.slice(-1)[0];
                            // Next event polling is done for events that have a timestamp later than the current latest event.
                            eventQueryTimestamp = lastEvent.timestamp;
                        }
                        // This solution sets the interval based on last query returning, opposed to not taking request-response cycles into account at all.
                        // This solution is more friendly to the Subgraph & more effective resource-wise with slow internet.
                        return [2 /*return*/, setTimeout(function () {
                                // Fire and forget
                                pollingStep();
                            }, ms)];
                }
            });
        }); };
        if (timeout) {
            setTimeout(function () {
                unsubscribe();
            }, timeout);
        }
        // Fire and forget
        pollingStep();
        return unsubscribe;
    };
    return Query;
}());
// Why? Because `return obj as T` and `return <T>obj` are not safe type casts.
var typeGuard = function (obj) { return obj; };

/**
 * @dev Superfluid Framework Class
 * @description The entrypoint for the SDK-core, `create` an instance of this for full functionality.
 */
var Framework = /** @class */ (function () {
    function Framework(options, settings) {
        var _this = this;
        /**
         * @dev Create a signer which can be used to sign transactions.
         * @param options.web3Provider a Web3Provider object (e.g. client side - metamask, web3modal)
         * @param options.provider an ethers Provider object (e.g. via Hardhat ethers)
         * @param options.privateKey a test account private key
         * @param options.signer a signer object (e.g. ethers.Wallet instance)
         * @returns `ethers.Signer` object
         */
        this.createSigner = function (options) {
            if (!options.privateKey &&
                !options.provider &&
                !options.signer &&
                !options.web3Provider) {
                throw new SFError({
                    type: "CREATE_SIGNER",
                    customMessage: "You must pass in a private key, provider or signer.",
                });
            }
            /* istanbul ignore else  */
            if (options.privateKey) {
                if (!options.provider) {
                    throw new SFError({
                        type: "CREATE_SIGNER",
                        customMessage: "You must pass in a provider with your private key.",
                    });
                }
                return new ethers.Wallet(options.privateKey, options.provider);
            }
            else if (options.signer) {
                return options.signer;
            }
            // NOTE: tested by sdk-redux already
            else if (options.web3Provider) {
                return options.web3Provider.getSigner();
            }
            /* istanbul ignore next */
            throw new SFError({
                type: "CREATE_SIGNER",
                customMessage: "Something went wrong, this should never occur.",
            });
        };
        /**
         * @dev Create a `BatchCall` class from the `Framework`.
         * @param operations the list of operations to execute
         * @returns `BatchCall` class
         */
        this.batchCall = function (operations) {
            return new BatchCall({ operations: operations, config: _this.settings.config });
        };
        /**
         * @dev Load a `SuperToken` class from the `Framework`.
         * @param address the `SuperToken` address
         * @returns `SuperToken` class
         */
        this.loadSuperToken = function (address) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, SuperToken.create(__assign(__assign({}, this.settings), { address: address }))];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        }); };
        this.userInputOptions = options;
        this.settings = settings;
        this.cfaV1 = new ConstantFlowAgreementV1({
            config: this.settings.config,
        });
        this.host = new Host(this.settings.config.hostAddress);
        this.idaV1 = new InstantDistributionAgreementV1({
            config: this.settings.config,
        });
        this.query = new Query(this.settings);
    }
    var _a;
    _a = Framework;
    /**
     * @dev Creates the Framework object based on user provided `options`.
     * @param options.chainId the chainId of your desired network (e.g. 137 = matic)
     * @param options.customSubgraphQueriesEndpoint your custom subgraph endpoint
     * @param options.dataMode the data mode you'd like the framework to use (SUBGRAPH_ONLY, SUBGRAPH_WEB3, WEB3_ONLY)
     * @param options.networkName the desired network (e.g. "matic", "rinkeby", etc.)
     * @param options.resolverAddress a custom resolver address (advanced use for testing)
     * @param options.protocolReleaseVersion a custom release version (advanced use for testing)
     * @param options.provider a provider object necessary for initializing the framework
     * @returns `Framework` class
     */
    Framework.create = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var networkName, chainId, releaseVersion, customSubgraphQueriesEndpoint, network, data, resolverAddress, resolver, superfluidLoaderAddress, superfluidLoader, framework, settings, err_1;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    validateFrameworkConstructorOptions(__assign(__assign({}, options), { dataMode: options.dataMode || "SUBGRAPH_ONLY", protocolReleaseVersion: options.protocolReleaseVersion || "v1" }));
                    networkName = getNetworkName(options);
                    chainId = options.chainId || networkNameToChainIdMap.get(networkName);
                    releaseVersion = options.protocolReleaseVersion || "v1";
                    customSubgraphQueriesEndpoint = options.dataMode === "WEB3_ONLY"
                        ? ""
                        : options.customSubgraphQueriesEndpoint ||
                            getSubgraphQueriesEndpoint(options);
                    return [4 /*yield*/, options.provider.getNetwork()];
                case 1:
                    network = _b.sent();
                    if (network.chainId !== chainId && chainId != null) {
                        throw new SFError({
                            type: "NETWORK_MISMATCH",
                            customMessage: "Your provider network chainId is: " +
                                network.chainId +
                                " whereas your desired chainId is: " +
                                chainId,
                        });
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 5, , 6]);
                    data = chainIdToDataMap.get(chainId) || {
                        subgraphAPIEndpoint: "",
                        resolverAddress: "",
                        networkName: "",
                    };
                    resolverAddress = options.resolverAddress
                        ? options.resolverAddress
                        : data.resolverAddress;
                    resolver = new ethers.Contract(resolverAddress, abi$6, options.provider);
                    return [4 /*yield*/, resolver.get("SuperfluidLoader-v1")];
                case 3:
                    superfluidLoaderAddress = _b.sent();
                    superfluidLoader = new ethers.Contract(superfluidLoaderAddress, abi$5, options.provider);
                    return [4 /*yield*/, superfluidLoader.loadFramework(releaseVersion)];
                case 4:
                    framework = _b.sent();
                    settings = {
                        chainId: chainId,
                        customSubgraphQueriesEndpoint: customSubgraphQueriesEndpoint,
                        dataMode: options.dataMode || "SUBGRAPH_ONLY",
                        protocolReleaseVersion: options.protocolReleaseVersion || "v1",
                        provider: options.provider,
                        networkName: networkName,
                        config: {
                            hostAddress: framework.superfluid,
                            superTokenFactoryAddress: framework.superTokenFactory,
                            cfaV1Address: framework.agreementCFAv1,
                            idaV1Address: framework.agreementIDAv1,
                        },
                    };
                    return [2 /*return*/, new Framework(options, settings)];
                case 5:
                    err_1 = _b.sent();
                    throw new SFError({
                        type: "FRAMEWORK_INITIALIZATION",
                        customMessage: "There was an error initializing the framework",
                        errorObject: err_1,
                    });
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return Framework;
}());

export { BatchCall, ConstantFlowAgreementV1, Framework, Host, InstantDistributionAgreementV1, Query, SuperToken, createLastIdPaging, createPagedResult, createSkipPaging, flowedAmountSinceUpdatedAt, getBalance, getPerSecondFlowRateByDay, getPerSecondFlowRateByMonth, getPerSecondFlowRateByYear, getSanitizedTimestamp, getStringCurrentTimeInSeconds, getTransactionDescription, isNullOrEmpty, nextLastIdPaging, nextSkipPaging, normalizeAddress, removeSigHashFromCallData, subscriptionTotalAmountClaimableSinceUpdatedAt, subscriptionTotalAmountDistributedSinceUpdated, subscriptionTotalAmountReceivedSinceUpdated, takePlusOne };
